import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal, message } from "antd";
import { DateTime } from "luxon";
import { buildAgentSignatureLabels, buyerCustomerDocsContractTypes, counterOfferContractTypes, createOfferContractTypes, customerDocsContractTypes, dateData, isSellingNotExecutedFunc, listingContractTypes, netSheetFieldsHiddenToTitleCompany, noChangeCheckboxContractTypes, sellerCustomerDocsContractTypes } from "../../Common/commondata/commonData";
import { features } from "./features";
import setDayOfWeek from "./helpers/setDayOfWeek";
import accounting from "accounting";
import calculatePriceTable from "./helpers/calculatePriceTable";
import { smallHelpersFun } from "./helpers/smallHeperFunctions";
import { formatPhoneNumber, getAttr } from "../../Common/utils/universalFuntions";
import moment from "moment";
import buildSignatureBlocksForAgents from "./helpers/buildSignatureBlocksForAgents";
import getFullNamesFromArray from "./helpers/getFullNamesFromArray";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import { calculateFinalNetSheetPrice } from "./helpers/netsheetAmtCalculater";
// import CBLogo from "../../Assets/ColdwelBanker-logo.png";
const { confirm } = Modal;

export const validateEmail = (email) => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(String(email).toLowerCase());
};
const showConfirm = (event, currentUrlId, handleInputSave, specificData, contractData) => {
  if (event?.target?.checked) {
    confirm({
      title: "Are you sure to fill the dates automatically?",
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      content: "Your manually filled dates will be lost. Do you still want to continue?",
      onOk() {
        handleDateFillFunction(event, currentUrlId, handleInputSave, specificData, contractData);
      },
      onCancel() {
        let allCheckBoxex = document.querySelectorAll(`input[name="AutoFillDates"]`);
        allCheckBoxex?.forEach((el) => {
          el.checked = false;
        });
      },
    });
  }
};

export function handleToggleAutoFillDates(event = {}, currentUrlId, handleInputSave, specificData, contractData) {
  if (event.target.checked) {
    let closingDate = JSON.parse(localStorage.getItem(currentUrlId))?.ClosingDate;
    closingDate = !isNaN(Date.parse(closingDate?.value)) ? moment(closingDate?.value) : !isNaN(Date.parse(closingDate)) ? moment(closingDate) : null;
    let originalContractDate = JSON.parse(localStorage.getItem(currentUrlId))?.OriginalContractDate || moment();
    originalContractDate = moment(originalContractDate);
    // console.log("closingDate", moment(closingDate).format("MM-DD-YYYY"),moment(originalContractDate).format("MM-DD-YYYY") )
    // Checking if the difference is less than 29 days
    if (closingDate && closingDate.diff(originalContractDate, "days") < 29) {
      message.info("Please select a closing date at least 30 days from the document initiation date to fill Table 3.1 dates automatically.", 4);
      event.target.checked = false;
      return;
    }
    showConfirm(event, currentUrlId, handleInputSave, specificData, contractData);
  } else {
    handleDateFillFunction(event, currentUrlId, handleInputSave, specificData, contractData);
  }
}

// Offers all the dates filled automattically
export function handleDateFillFunction(event, currentUrlId, handleInputSave, specificData, contractData) {
  if (!event.target.checked) {
    smallHelpersFun.updateElements("checkbox", `input[name=${event.target.name}]`, false);
    specificData[event.target.name] = "";
    let mainLocalData = JSON.parse(localStorage.getItem(currentUrlId));
    mainLocalData[event?.target?.name] = "";
    localStorage.setItem(currentUrlId, JSON.stringify(mainLocalData));
    dateData.forEach((ele) => {
      let localData = JSON.parse(localStorage.getItem(currentUrlId));
      if (ele.canRemoved) {
        let eleValue = localData[ele.keyName];
        if (eleValue) {
          setDayOfWeek({
            name: ele.keyName,
            value: "",
          });
          smallHelpersFun.updateElements("input", `input[name=${ele.keyName}]`, "");
          if (ele.type === "date") {
            specificData[ele.keyName] = {
              type: "text",
              value: "N/A",
            };
            localData[`${ele.keyName}`] = {
              type: "text",
              value: "N/A",
            };
          } else {
            specificData[ele.keyName] = "";
            localData[`${ele.keyName}`] = "";
          }
          localStorage.setItem(currentUrlId, JSON.stringify(localData));
        }
      }
    });
    handleInputSave(specificData);
  } else {
    smallHelpersFun.updateElements("checkbox", `input[name=${event.target.name}]`, true);
    specificData[event?.target?.name] = event?.target?.value;
    let mainLocalData = JSON.parse(localStorage.getItem(currentUrlId));
    mainLocalData[event?.target?.name] = event?.target?.value;
    localStorage.setItem(currentUrlId, JSON.stringify(mainLocalData));
    features.autoFillDateLogic({ currentUrlId, source: "ToggleCheckbox", specificData, contractData });
    handleInputSave(specificData);
  }
}

export const ctrlShiftKey = (e, keyCode) => {
  return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
};

export const d = {
  el: {
    // get Element/s capital A is all elements
    id: (id) => document.getElementById(id),
    q: (selector) => document.querySelector(selector),
    qA: (selector) => document.querySelectorAll(selector),
    clA: (className) => document.getElementsByClassName(className),
    nA: (name) => document.getElementsByName(name),
    tgA: (tagName) => document.getElementsByTagName(tagName),

    // create Element
    Cr8: (tagName) => document.createElement(tagName),

    // remove Element
    r: (element) => element.remove(),

    // style an element
    s: (element, styles) => {
      for (let property in styles) {
        element.style[property] = styles[property];
      }
    },
    sM: (elements, styles) => {
      for (let i = 0; i < elements.length; i++) {
        for (let property in styles) {
          elements[i].style[property] = styles[property];
        }
      }
    },

    // attributes M is multiple attributes
    at: {
      s: (attributeName, value, element) => element.setAttribute(attributeName, value),
      g: (attributeName, element) => element.getAttribute(attributeName),
      sM: (attributes, element) => {
        for (let attribute in attributes) {
          element.setAttribute(attribute, attributes[attribute]);
        }
      },
      gM: (attributesArray, element) => {
        const attributes = {};
        for (let i = 0; i < attributesArray.length; i++) {
          attributes.push(element.getAttribute(attributesArray[i]));
        }
        return attributes;
      },
    },

    // append
    ap: (child, element) => element.append(child),

    // add eventListener
    ev: {
      a: (eventType, callback, element) => {
        element.addEventListener(eventType, callback);
      },
      r: (eventType, callback, element) => {
        element.removeEventListener(eventType, callback);
      },
    },
  },

  // localStorage
  l: {
    // setItem s -> non stringified, sS  -> stringified
    s: (itemName, item) => localStorage.setItem(itemName, item),
    sS: (itemName, item) => localStorage.setItem(itemName, JSON.stringify(item)),
    // getItem g -> non parsed, gP -> parsed
    g: (itemName) => localStorage.getItem(itemName),
    gP: (itemName) => JSON.parse(localStorage.getItem(itemName) || {}),
  },

  // consoles
  lg: function () {},
};

export function makeAllFieldsDisabled(currentUrlId, rootDocData, contractData) {
  const { openFor, contractType, RTDInitiator, signatureInfo, builtForSection, createOrEditTemplate, isOfferClone, buyerDocumentStatus, signable, buyerIds, checkForDisable, buyerAgentId, propertyId, propertyData } = rootDocData || {};

  let localData = JSON.parse(localStorage.getItem(currentUrlId));
  if (!localData) {
    return;
  }
  const inputElements = document.querySelectorAll("input, textarea");
  const buyerAddButton = document.querySelectorAll(`[data-buyer-edit-icon]`);
  const sellerAddButton = document.querySelectorAll(`[data-seller-edit-icon]`);
  const addDocsClausesBtns = document.querySelectorAll(`[data-add-docclause]`);
  const addTitleOfficeBtn = document.querySelectorAll(`[data-add-title-office]`);
  const coBuyerBrokerEditBtn = document.querySelectorAll(`[data-co-buyer-broker-edit-icon]`);
  const coSellerBrokerEditBtn = document.querySelectorAll(`[data-co-seller-broker-edit-icon]`);
  const coBuyerBrokerDeleteBtn = document.querySelectorAll(`[data-co-buyer-broker-delete-icon]`);
  const coSellerBrokerDeleteBtn = document.querySelectorAll(`[data-co-seller-broker-delete-icon]`);
  const addCoBuyerBrokerBtn = document.querySelectorAll(`[data-add-coBuyerBroker-btn]`);
  const addCoSellerBrokerBtn = document.querySelectorAll(`[data-add-coSellerBroker-btn]`);
  const editBuyerDetailsBtn = document.querySelectorAll(`[data-buyer-details-edit-icon]`);
  const editSellerDetailsBtn = document.querySelectorAll(`[data-seller-details-edit-icon]`);
  const buyerForms = document.getElementById("buyerAgentFields");
  const sellerForms = document.getElementById("sellerAgentFields");
  const buyerAgentIdFields = document.getElementById("buyerAgentIdFields");
  const sellerAgentIdFields = document.getElementById("sellerAgentIdFields");
  const signatureBlocks = document.querySelectorAll(".signature-block");
  const ListingPeriodBeginDate = document.getElementsByName("ListingPeriodBeginDate");
  const ListingPeriodEndByDate = document.getElementsByName("ListingPeriodEndByDate");
  const propertyAddress = document.getElementsByName("FullAddress");
  const buyersSignWithDrawBlock = document.querySelector(`input[name=LetBuyersSignWithDrawBlock]`);
  const lbpdBuyerEditableFields = document.getElementsByName("BuyerHasElectedTo");
  const corpSignersList = document.getElementById("corpSignersList");
  const netSheetAddItemBtn = document.querySelectorAll(`[data-add-item]`);
  const netSheetAddLoanBtn = document.querySelectorAll(`[data-add-loan]`);
  const netSheetRemoveItemBtn = document.querySelectorAll(`[data-remove-item]`);
  const sowCoBtn = document.querySelector(`[data-select-sow]`);
  const sowCoBtnParent = document.querySelector(`.searchBtn`);
  const modifyDateTableRuleBtn = document.querySelectorAll(`[data-modifyDateTableRule]`);
  const OriginalContractDate = document.querySelectorAll('[name="OriginalContractDate"]');
  const ErtbDateFields = document.getElementsByName("ERTBOriginalContractDate");
  const ErtsDateFields = document.getElementsByName("ERTSOriginalContractDate");
  const titleSignerListModalBtn = document.querySelectorAll(`[data-title-signer-list]`);
  const titleSignerDeleteBtn = document.querySelectorAll(`[data-title-signer-delete]`);
  const LoanCalculatorIconInWyoming = document.querySelectorAll(`[data-calculate-loan]`);

  if (ListingPeriodBeginDate && ListingPeriodEndByDate && [...listingContractTypes, "ERTB", "CB_ERTB", "ERTL", "ETCT", "WY_ERTB_BA", "WY_ERTB_I"].includes(contractType)) {
    const oneDayBefore = smallHelpersFun.adjustDate(ListingPeriodEndByDate[0]?.value, -1);
    const oneDayAfter = smallHelpersFun.adjustDate(ListingPeriodBeginDate[0]?.value, 1);
    if (oneDayBefore) {
      ListingPeriodBeginDate.forEach(function (element) {
        element.max = oneDayBefore;
      });
    }
    if (oneDayAfter) {
      ListingPeriodEndByDate.forEach(function (element) {
        element.min = oneDayAfter;
      });
    }
  }
  if (["LCAE", "WY_ATAE_ERTB", "LCAES", "LCAES_ERTL", "LCAES_ETCT"].includes(contractType) && ListingPeriodEndByDate) {
    let startDate = localData["ListingPeriodBeginDate"];
    const oneDayAfter = smallHelpersFun.adjustDate(startDate, 1);
    if (oneDayAfter) {
      ListingPeriodEndByDate.forEach(function (element) {
        element.min = oneDayAfter;
      });
    }
  }
  let buyersCount = 0;
  buyerIds?.forEach((el) => {
    if (el.isCorp) {
      buyersCount += el.signers?.length;
    } else {
      buyersCount += 1;
    }
  });
  const anyOneSigned = (signatureInfo || []).length > 0;
  let anyBuyerSideSigned = false,
    anyBuyerSigned=false,
    anySellerSideSigned = false,
    allBuyersSigned = false,
    anyBuyerAgentSigned = false,
    anySellerAgentSigned = false;
  signatureInfo?.forEach((element) => {
    if (element.roleType === "BUYER" || element.roleType === "BUYER_AGENT") {
      anyBuyerSideSigned = true;
      if(element.roleType === "BUYER") {
        anyBuyerSigned = true;
      }
      if (element.roleType === "BUYER_AGENT") {
        anyBuyerAgentSigned = true;
      }
    } else {
      anySellerSideSigned = true;
      if (element.roleType === "SELLER_AGENT") {
        anySellerAgentSigned = true;
      }
    }
  });
  if (buyerDocumentStatus === "SUBMITTED") {
    allBuyersSigned = true;
  }
  const conditionalDisableElements = (forms, effect) => {
    if (forms) {
      const readOnlyEffect = effect === "none" ? true : false;
      forms.querySelectorAll("input, textarea")?.forEach((element) => {
        handleSingleElementDisable({ element, readOnlyEffect, effect });
      });
      const coBuyerBrokerEditBtn = forms.querySelectorAll(`[data-co-buyer-broker-edit-icon]`);
      const coSellerBrokerEditBtn = forms.querySelectorAll(`[data-co-seller-broker-edit-icon]`);
      const coBuyerBrokerDeleteBtn = forms.querySelectorAll(`[data-co-buyer-broker-delete-icon]`);
      const coSellerBrokerDeleteBtn = forms.querySelectorAll(`[data-co-seller-broker-delete-icon]`);
      disableElements([coBuyerBrokerEditBtn, coSellerBrokerEditBtn, coBuyerBrokerDeleteBtn, coSellerBrokerDeleteBtn], effect);
    }
  };

  const handleSingleElementDisable = ({ element, readOnlyEffect, effect }) => {
    if (!element?.style) return;
    if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
      if (!["checkbox", "radio", "date"].includes(element.type) && !element.classList.contains("relativeDateInput") && !element.classList.contains("relativeTimeInput") && element.name !== "FullAddress" && element?.getAttribute?.("data-select-box") !== "YesNoUnknown") {
        element.readOnly = readOnlyEffect;
        // Adding or removing class based on readOnlyEffect
        element.classList.toggle("noAutoSave", readOnlyEffect);
      } else {
        element.style.pointerEvents = effect;
      }
    } else {
      element.style.pointerEvents = effect;
      if (element.classList.contains("bi-pencil-square")) {
        element.style.color = effect === "none" ? "#808080" : "#0000FF";
      }
    }
  };

  const disableElements = (elements, effect) => {
    const readOnlyEffect = effect === "none" ? true : false;
    elements = Array.isArray(elements) ? elements : [elements];
    elements.forEach((element) => {
      if (element instanceof NodeList || Array.isArray(element)) {
        element.forEach((node) => {
          handleSingleElementDisable({ element: node, readOnlyEffect, effect });
        });
      } else {
        handleSingleElementDisable({ element, readOnlyEffect, effect });
      }
    });
  };

  const hideOrShowElements = (elements, effect, type) => {
    elements = Array.isArray(elements) ? elements : [elements];
    elements.forEach((element) => {
      if (element instanceof NodeList || Array.isArray(element)) {
        element.forEach((node) => {
          if (node && node.style) {
            node.style.display = effect;
          }
        });
      } else {
        if (element && element.style) {
          element.style.display = effect;
        }
      }
    });
  };

  const disableElementsByName = (arrayOfInputNames = [], effect) => {
    arrayOfInputNames.forEach((el) => {
      let inputElement = document.querySelectorAll(`[name="${el}"]`);
      disableElements(inputElement, effect);
    });
  };

  const disableAllElements = (effect="none") => {
    disableElements(inputElements, effect);
    disableElements(addDocsClausesBtns, effect);
    disableElements(addTitleOfficeBtn, effect);
    hideOrShowElements([addCoBuyerBrokerBtn, addCoSellerBrokerBtn, coBuyerBrokerEditBtn, coSellerBrokerEditBtn, coBuyerBrokerDeleteBtn, coSellerBrokerDeleteBtn, editBuyerDetailsBtn, editSellerDetailsBtn], effect);
    hideOrShowElements([netSheetAddItemBtn, netSheetAddLoanBtn, netSheetRemoveItemBtn, modifyDateTableRuleBtn], effect);
    hideOrShowElements([sowCoBtn, sowCoBtnParent], effect);
    disableElements(titleSignerListModalBtn, effect);
    disableElements(titleSignerDeleteBtn, effect);
    disableElements(LoanCalculatorIconInWyoming, effect);
    if (contractType === "BHHS_CP_RA") {
      hideOrShowElements([buyerAddButton, sellerAddButton], effect);
    } else {
      disableElements([buyerAddButton, sellerAddButton, addTitleOfficeBtn], effect);
    }
    conditionalDisableElements(buyerForms, effect);
    conditionalDisableElements(sellerForms, effect);
  };


const isClientFieldsDisabled = !rootDocData?.signatureSequence?.enableFieldsForClients && (openFor === "BUYER" || openFor === "SELLER");
  const isCrossInitiatedRTD = rootDocData?.signatureSequence?.enableFieldsForClients && ((openFor === "BUYER" && RTDInitiator === "SELLER") || (openFor === "SELLER" && RTDInitiator === "BUYER"));
if (anyOneSigned || isClientFieldsDisabled || isCrossInitiatedRTD || (openFor === "SELLER_AGENT" && !allBuyersSigned && isOfferClone)) {
  disableAllElements();
}
  // console.log("contractType", contractType, RTDInitiator, openFor, sellerForms);
  if (createOfferContractTypes.includes(rootDocData?.contractType)) {
    switch (openFor) {
      case "BUYER_AGENT":
        if (Array.isArray(propertyData?.propertyType) && propertyData.propertyType.includes("PRIVATE")) {
          hideOrShowElements([addCoSellerBrokerBtn, coSellerBrokerDeleteBtn], "none");
        }
        hideOrShowElements([editSellerDetailsBtn], "none");
        if (!anyBuyerAgentSigned) {
          conditionalDisableElements(buyerForms, "auto");
          hideOrShowElements([addCoBuyerBrokerBtn, coBuyerBrokerEditBtn, coBuyerBrokerDeleteBtn], "inline-block");
        }
        if (!anyOneSigned && !localData?.SellerAgents?.length) {
          hideOrShowElements([coSellerBrokerEditBtn, addCoSellerBrokerBtn, coSellerBrokerDeleteBtn], "inline-block");
        }
        break;
      case "BUYER":
        hideOrShowElements([addCoBuyerBrokerBtn, addCoSellerBrokerBtn, coBuyerBrokerEditBtn, coSellerBrokerEditBtn, coBuyerBrokerDeleteBtn, coSellerBrokerDeleteBtn, editBuyerDetailsBtn, editSellerDetailsBtn], "none");
        disableElements([buyerAddButton, sellerAddButton, addTitleOfficeBtn], "none");
        break;

      case "SELLER_AGENT":
        disableAllElements();

        if (!anySellerSideSigned) {
          hideOrShowElements([editSellerDetailsBtn], "inline-block");
          disableElements([sellerAddButton], "auto");
          conditionalDisableElements(corpSignersList, "auto");
        }

        if (!anySellerAgentSigned) {
          conditionalDisableElements(sellerForms, "auto");
          hideOrShowElements([coSellerBrokerEditBtn, addCoSellerBrokerBtn, coSellerBrokerDeleteBtn], "inline-block");
        }
        break;

      default:
        disableAllElements();
        break;
    }

    // Common code
    if (!buyerAgentId && buyerAgentIdFields) {
      buyerAgentIdFields.style.display = "none";
    }

    if (!localData["SellerBrokerName"] && sellerAgentIdFields) {
      sellerAgentIdFields.style.display = "none";
    }
  }

  if (!createOfferContractTypes.includes(contractType) && !contractType.startsWith("HH_")) {
    switch (RTDInitiator) {
      case "BUYER":
        if (openFor === "BUYER_AGENT") {
          hideOrShowElements([addCoSellerBrokerBtn, coSellerBrokerDeleteBtn, editSellerDetailsBtn], "none");
          disableElements(OriginalContractDate, "auto");
          if (contractType === "DC_BCLA" && localData["BuyerAgents"]?.length >= 2) {
            hideOrShowElements([addCoBuyerBrokerBtn], "none");
          }
          // only seller can fill out these documents
          if (["WY_SPDPB", "WY_VLPD"].includes(contractType)) {
            disableAllElements("none");
            if (!anyBuyerSideSigned) {
              disableElements([buyerAddButton, !anyOneSigned && sellerAddButton], "auto");
            }
          }
            if (contractType === "WY_CAICTD" && !anyOneSigned) {
              disableElements([ErtbDateFields], "auto");
            }
        } else if (openFor === "BUYER") {
          hideOrShowElements([addCoBuyerBrokerBtn, addCoSellerBrokerBtn, coBuyerBrokerEditBtn, coSellerBrokerEditBtn, coBuyerBrokerDeleteBtn, coSellerBrokerDeleteBtn, editBuyerDetailsBtn, editSellerDetailsBtn], "none");
          if (contractType === "BHHS_CP_RA") {
            hideOrShowElements([buyerAddButton, sellerAddButton], "none");
          } else {
            disableElements([buyerAddButton, sellerAddButton, addTitleOfficeBtn], "none");
          }
          if (buyersSignWithDrawBlock) {
            buyersSignWithDrawBlock.style.pointerEvents = "none";
          }
          disableElements(OriginalContractDate, "auto");
        } else if (openFor === "SELLER_AGENT") {
          disableAllElements();
          if (!anySellerSideSigned) {
            conditionalDisableElements(corpSignersList, "auto");
            hideOrShowElements([editSellerDetailsBtn], "inline-block");
            disableElements([sellerAddButton], "auto");
          } 
          if (contractType === "WY_CO" ? !anySellerSideSigned : !anySellerAgentSigned) {
            conditionalDisableElements(sellerForms, "auto");
            hideOrShowElements([addCoSellerBrokerBtn, coSellerBrokerEditBtn, coSellerBrokerDeleteBtn], "inline-block");
          }
        } else if (openFor === "SELLER") {
          // only seller can fill out these documents
          if (["WY_SPDPB", "WY_VLPD"].includes(contractType) && !anyOneSigned) {
            disableAllElements("auto");
            disableElements([buyerAddButton, sellerAddButton], "none");
          }
        }
        if (contractType === "COS" && sellerForms) {
          sellerForms.style.display = "none";
        }
      
        break;
    case "SELLER":
        if (openFor === "SELLER_AGENT") {
          if (!rootDocData?.offerId) {
            conditionalDisableElements(buyerForms, "none");
            hideOrShowElements([coBuyerBrokerEditBtn], "none");
            if (![...listingContractTypes, ...customerDocsContractTypes].includes(contractType) && !propertyId) {
              hideOrShowElements([addCoSellerBrokerBtn, coSellerBrokerDeleteBtn], "none");
            }
          }
          hideOrShowElements([addCoBuyerBrokerBtn, coBuyerBrokerDeleteBtn, editBuyerDetailsBtn], "none");
          disableElements(OriginalContractDate, "auto");
          if (contractType === "DC_CLASLC" && localData["SellerAgents"]?.length >= 2) {
            hideOrShowElements([addCoSellerBrokerBtn], "none");
          }
          // only seller can fill out these documents
          if (["WY_SPDPB", "WY_VLPD"].includes(contractType)) {
            disableAllElements("none");
            if (!anySellerSideSigned) {
              disableElements([!anyBuyerSigned && buyerAddButton, sellerAddButton], "auto");
            }
          }
          if (contractType === "WY_CAICTD" && !anyOneSigned) {
            disableElements([ErtsDateFields], "auto");
          } 
         // this one is for all document so that any wrong buyer can be corrected until any Buer has signed the document
          if (!anyBuyerSigned) {
            disableElements([buyerAddButton], "auto");
            conditionalDisableElements(corpSignersList, "auto");
          }
        } else if (openFor === "SELLER") {
          hideOrShowElements([addCoBuyerBrokerBtn, addCoSellerBrokerBtn, coBuyerBrokerEditBtn, coSellerBrokerEditBtn, coBuyerBrokerDeleteBtn, coSellerBrokerDeleteBtn, editBuyerDetailsBtn, editSellerDetailsBtn], "none");
          if (contractType === "BHHS_CP_RA") {
            hideOrShowElements([buyerAddButton, sellerAddButton], "none");
          } else {
            disableElements([buyerAddButton, sellerAddButton, addTitleOfficeBtn], "none");
          }
          if (buyersSignWithDrawBlock) {
            buyersSignWithDrawBlock.style.pointerEvents = "none";
          }
          disableElements(OriginalContractDate, "auto");
          // only seller can fill out these documents
          if (["WY_SPDPB", "WY_VLPD"].includes(contractType) && !anyOneSigned) {
            disableAllElements("auto");
            disableElements([buyerAddButton, sellerAddButton], "none");
          }
        } else if (openFor === "BUYER_AGENT") {
          disableAllElements();
          if (!anyBuyerSideSigned) {
            conditionalDisableElements(corpSignersList, "auto");
            hideOrShowElements([editBuyerDetailsBtn], "inline-block");
            if (contractType === "BHHS_CP_RA") {
              hideOrShowElements([buyerAddButton], "inline-block");
            } 
          }
           // this one is for all document so that any wrong buyer can be corrected until any Buer has signed the document
          if (!anyBuyerSigned) {
            disableElements([buyerAddButton], "auto");
            conditionalDisableElements(corpSignersList, "auto");
          }
          if (contractType === "WY_CO" ? !anyBuyerSideSigned : !anyBuyerAgentSigned) {
            conditionalDisableElements(buyerForms, "auto");
            hideOrShowElements([addCoBuyerBrokerBtn, coBuyerBrokerEditBtn, coBuyerBrokerDeleteBtn], "inline-block");
          }
        }
        if (contractType === "COS" && buyerForms) {
          buyerForms.style.display = "none";
        }
        break;
      default:
        if (builtForSection === "DOCUMENT") {
          disableAllElements();
        }
        break;
    }

    if (buyersSignWithDrawBlock && openFor === "BUYER_AGENT" && RTDInitiator === "BUYER" && buyersCount === signatureInfo?.length) {
      buyersSignWithDrawBlock.style.pointerEvents = "auto";
    }
    // LBPD form > Buyers Acknowledgement fields should be editable by Buying side only
    if (contractType === "LBPD" && lbpdBuyerEditableFields) {
      if ((openFor === "BUYER" || openFor === "BUYER_AGENT") && !anyBuyerSideSigned) {
        disableElements(lbpdBuyerEditableFields, "auto"); // Enable for buying side
      } else {
        disableElements(lbpdBuyerEditableFields, "none"); // Disable for selling side
      }
    }
    if (!buyerAgentId && buyerAgentIdFields) {
      buyerAgentIdFields.style.display = "none";
    }
    if (!localData["SellerBrokerName"] && sellerAgentIdFields) {
      sellerAgentIdFields.style.display = "none";
    }
  }

  if (builtForSection === "TEMPLATE") {
    if (createOrEditTemplate) {
      hideOrShowElements([addCoBuyerBrokerBtn, coBuyerBrokerEditBtn, coBuyerBrokerDeleteBtn, addCoSellerBrokerBtn, coSellerBrokerEditBtn, coSellerBrokerDeleteBtn], "none");
      if (contractType === "BHHS_CP_RA") {
        hideOrShowElements([buyerAddButton, sellerAddButton], "none");
      } else {
        disableElements([buyerAddButton, sellerAddButton, addTitleOfficeBtn], "none");
      }
      disableElements(signatureBlocks, "none");
      disableElementsByName(contractData?.templateDisabledFields || [], "none");
      if (contractType === "NET_SHEET") {
        const addLoanBtn = document.querySelectorAll(`[data-add-loan]`);
        if (addLoanBtn) hideOrShowElements([addLoanBtn], "none");
        const loanKeys = Object.keys(localData).filter((key) => /^Loan\d+$/.test(key));
        disableElementsByName(loanKeys || [], "none");
      }
    } else {
      disableAllElements();
    }
  } else if (builtForSection === "DOCUMENT_SET") {
    hideOrShowElements([addCoBuyerBrokerBtn, coBuyerBrokerEditBtn, coBuyerBrokerDeleteBtn, addCoSellerBrokerBtn, coSellerBrokerEditBtn, coSellerBrokerDeleteBtn], "none");
    if (contractType === "BHHS_CP_RA") {
      hideOrShowElements([buyerAddButton, sellerAddButton], "none");
    } else {
      disableElements([buyerAddButton, sellerAddButton, addTitleOfficeBtn], "none");
    }
    disableElements(signatureBlocks, "none");
    disableElementsByName(contractData?.templateDisabledFields || [], "none");
    if (contractType === "NET_SHEET") {
      const addLoanBtn = document.querySelectorAll(`[data-add-loan]`);
      if (addLoanBtn) hideOrShowElements([addLoanBtn], "none");
      const loanKeys = Object.keys(localData).filter((key) => /^Loan\d+$/.test(key));
      disableElementsByName(loanKeys || [], "none");
    }
  }

  if (!contractData?.propertyAddressEditable || anyOneSigned) {
    disableElementsByName(propertyAddress, "none");
  }
  // whole document will be completely disabled if any of the below fields becomes true
  if (checkForDisable?.disabled || builtForSection === "READ_ONLY_DOCUMENT" || localData["invalidated"] || localData["onlyTemplateview"] === true) {
    disableAllElements();
  }

  // enabling the title of signer input field in following document
  if (["CI", "HH_CRA", "HH_LRA"].includes(rootDocData?.contractType) && signable) {
    const signerTitleInputField = document.getElementById("SignerTitleField");
    if (signerTitleInputField) {
      const titleCompanySigned = signatureInfo?.some((info) => info?.roleType === "TITLE_COMPANY");
      const shouldEnable = builtForSection === "READ_ONLY_DOCUMENT" && openFor === "TITLE_COMPANY" && !titleCompanySigned && !checkForDisable?.disabled;
      disableElements(signerTitleInputField, shouldEnable ? "auto" : "none");
    }
  }

  if (modifyDateTableRuleBtn && createOfferContractTypes.includes(contractType) && (builtForSection === "TEMPLATE" || anyOneSigned)) {
    hideOrShowElements([modifyDateTableRuleBtn], "none");
  }

  handleIfPresent({signatureSequence: contractData?.signatureSequence, localData});
  if (signatureInfo) {
    signatureInfo?.forEach((signatureBlock) => {
      const { roleType, key } = signatureBlock;
      //to disable sections on basis of signatures present
      if(contractData?.signatureSequence?.disableElements?.length > 0){
        for(let element of contractData?.signatureSequence?.disableElements){
          const keyValue = key?.split("_");
          const lastKeyValue = keyValue?.[keyValue?.length - 1];
          let currentIdx;
          if(!isNaN(Number(lastKeyValue))){
            currentIdx = Number(lastKeyValue);
          }

          //check if in present elements
          element?.ifPresent?.forEach((ele)=>{
            if(typeof ele === 'object')return;
            const splitValue = ele?.split("_");
            const lastValue = splitValue?.[splitValue?.length - 1];
            let presentRoleType = ele;
            let presentIdx;
            if(!isNaN(Number(lastValue))){
              presentRoleType = ele?.split?.('_'+ lastValue)?.[0];
            }
            if(!isNaN(Number(lastValue))){
              presentIdx = Number(lastValue);
            }

            //check and modify singature disable's
            if((roleType === presentRoleType) && (currentIdx === presentIdx)){
              disableElementsByName(element?.inputs || [], "none");
            }
          })
        }
      }
    });
  }
}

export function handleToggleAutoPriceCalculation(event, currentUrlId, handleInputSave, specificData) {
  const fieldsToGet = ["PurchasePrice", "EarnestMoney", "NewLoan", "AssumptionBalance", "PrivateFinancing", "SellerFinancing", "AdditionalPriceAmt1", "AdditionalPriceAmt2"];
  const tableValues = {};
  const updateValuesAndDOM = (values, action) => {
    for (const key in values) {
      specificData[key] = values[key];
      document.getElementsByName(key)?.forEach((element) => {
        element.value = values[key];
        element.parentNode.dataset.replicatedValue = values[key];
      });
    }
    const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    localStorage.setItem(currentUrlId, JSON.stringify({ ...localData, ...specificData }));
    handleInputSave(specificData);
  };

  fieldsToGet.forEach((field) => {
    let elements;
    if (event.target.checked) {
      elements = [document.querySelector(`[name="${field}"]`)];
    } else {
      elements = document.getElementsByName(field);
    }
    const value = elements?.[0]?.value ? accounting.unformat(elements[0].value) : event.target.checked ? 0.0 : 0;
    tableValues[field] = field === "PurchasePrice" ? value : 0.0;
  });
  const updatedValues = calculatePriceTable(tableValues, event.target.checked ? undefined : "CheckboxUnchecked");
  updateValuesAndDOM(updatedValues);
}

export function handleSignatureCompletion({signatureBlock, signatureSequence}) {
  if (!signatureBlock) return;
  const { _id, sign, initials, timeStamp, roleType, key, labelType } = signatureBlock;
  let signatureDate = timeStamp ? DateTime.fromMillis(timeStamp, { zone: "America/Denver" }).toFormat("MM/dd/yyyy") : "";
  let signatureTime = timeStamp ? DateTime.fromMillis(timeStamp, { zone: "America/Denver" }).toFormat("hh:mm a") : "";
  let parentElement;
  if (key && _id && labelType) {
    parentElement = document.getElementById(roleType + "_" + _id + "_key_" + key + "_" + labelType);
  } else if (key && _id) {
    parentElement = document.getElementById(roleType + "_" + _id + "_key_" + key);
    // console.log("parentElement", parentElement);
  } else {
    parentElement = document.getElementById(roleType + "_" + (_id || roleType));
    if (!parentElement) {
      parentElement = document.getElementById(roleType + "_" + (_id || roleType) + "_key_" + key);
    }
  }

  //to disable sections on basis of signatures present
  if(signatureSequence?.disableElements?.length > 0){
    for(let element of signatureSequence?.disableElements){
      const keyValue = key?.split("_");
      const lastKeyValue = keyValue?.[keyValue?.length - 1];
      let currentIdx;
      if(!isNaN(Number(lastKeyValue))){
        currentIdx = Number(lastKeyValue);
      }

      //check if in present elements
      element?.ifPresent?.forEach((ele)=>{
        if(typeof ele === 'object')return;
        const splitValue = ele?.split("_");
        const lastValue = splitValue?.[splitValue?.length - 1];
        let presentRoleType = ele;
        let presentIdx;
        if(!isNaN(Number(lastValue))){
          presentRoleType = ele?.split?.('_'+ lastValue)?.[0];
        }
        if(!isNaN(Number(lastValue))){
          presentIdx = Number(lastValue);
        }
      
        presentRoleType = presentRoleType?.replace(/-[A-Z]+$/, '');
       // console.log("presentRoleType", { presentRoleType, roleType, currentIdx }, "presentIdx", presentIdx);
        //check and modify singature disable's
        if((roleType === presentRoleType) && (currentIdx === presentIdx)){
          element?.signatures?.forEach((disableEle)=>{
            const block = document.querySelector(`[data-signature-block="${disableEle}"]`);

            if (block) {
              const activeSigners = block.querySelectorAll('.active-signer');
              activeSigners.forEach((el) => {
                el.classList.remove('active-signer');
                el.classList.remove('clickable');
                el.classList.add('inactive-signer');
              });
            }
          })
        }
      })
    }
  }


  if (parentElement) {
    const verifiedSignDiv = document.createElement("div");
    verifiedSignDiv.className = "signature-block signature-wrapper";
    verifiedSignDiv.innerHTML = `
    <div class="signature-block signature-img">
      <img src="${sign}" alt="Sign"/>
    </div>
    <div class="signature-block signature-verification">RE-Sure Verified<br /> ${initials !== undefined ? timeStamp + initials : timeStamp}</div>
  `;
    parentElement.innerHTML = "";
    parentElement.appendChild(verifiedSignDiv);
  }
  let signatureDateElement;
  if (key && _id && labelType) {
    signatureDateElement = document.querySelector(`[data-signatureDate="${roleType + "_" + _id + "_key_" + key + "_" + labelType}"]`);
  } else if (roleType === "TITLE_COMPANY") {
     signatureDateElement = document.querySelector(`[data-signatureDate="${roleType + "_" + roleType + "_key_" + key}"]`);
  } else if (key && _id) {
    signatureDateElement = document.querySelector(`[data-signatureDate="${roleType + "_" + _id + "_key_" + key}"]`);
  } else {
    signatureDateElement = document.querySelector(`[data-signatureDate="${roleType + "_" + (_id || roleType)}"]`);
  }
  //  console.log("signatureDateElement", signatureDateElement);
  if (signatureDateElement) {
    signatureDateElement.textContent = signatureDate || "";
  }
  // Time element
  let signatureTimeElement;
  if (key && _id && labelType) {
    signatureTimeElement = document.querySelector(`[data-signatureTime="${roleType + "_" + _id + "_key_" + key + "_" + labelType}"]`);
  } else if (key && _id) {
    signatureTimeElement = document.querySelector(`[data-signatureTime="${roleType + "_" + _id + "_key_" + key}"]`);
  } else {
    signatureTimeElement = document.querySelector(`[data-signatureTime="${roleType + "_" + (_id || roleType)}"]`);
  }
  if (signatureTimeElement) {
    signatureTimeElement.textContent = signatureTime || "";
  }
}

// for splitting older transactions office details at top header on offer forms
const formatOfficeDetails = (officeDetails) => {
  const nameAndAddress = officeDetails?.nameandAddress;
  if (!nameAndAddress) return "";
  const parts = nameAndAddress.split(" - ");

  // If the last part starts with a number, treat it as the address
  const lastPart = parts[parts.length - 1];
  if (/^\d/.test(lastPart)) {
    // Join all parts except the last as the company name
    const companyName = parts.slice(0, parts.length - 1).join(" - ");
    // Return company name on one line, and the address (last part) on the next line
    return `${companyName}\n${lastPart}`;
  }

  // If no valid address part found, return the original string
  return nameAndAddress;
};

export const getInitiatingAgentDetails = ({ localData, rootDocData }) => {
  let agentData = {};
  let { officeDetails: { agentId } = {} } = localData || {};
  if (rootDocData?.RTDInitiator === "SELLER") {
    if (agentId) {
      agentData = localData?.SellerAgents?.find((agent) => String(agent?.personId) === String(agentId)) || {};
    } else {
      agentData = localData?.SellerAgents?.[0] || {};
    }
  } else if (rootDocData?.RTDInitiator === "BUYER") {
    if (agentId) {
      agentData = localData?.BuyerAgents?.find((agent) => String(agent?.personId) === String(agentId)) || {};
    } else {
      agentData = localData?.BuyerAgents?.[0] || {};
    }
  }
  return agentData;
};
export function showCompanyDetails(td, rootDocData) {
  if (!td) return;
  const agentOfficeLogo = document.querySelector("#agentOfficeLogo");
  let { officeDetails: { officeLogo } = {} } = td || {};
  const agentData = getInitiatingAgentDetails({ localData: td, rootDocData });
  if (!agentData || !Object.keys(agentData)?.length) return;
  const setLogoAttributes = () => {
    agentOfficeLogo.innerHTML = "";
    if (!officeLogo) return;
    // Seting a temporary image to calculate our image original dimensions
    const tempImage = new Image();
    tempImage.src = officeLogo;
    tempImage.onload = () => {
      const aspectRatio = tempImage.width / tempImage.height;
      const desiredWidth = 100;
      const calculatedHeight = desiredWidth / aspectRatio;
      const logoHtml = `<img src="${officeLogo}" alt="Office Logo" width="${desiredWidth}px" height="${calculatedHeight}px" />`;
      agentOfficeLogo.innerHTML = logoHtml;
    };
  };

  if (agentOfficeLogo && td?.officeDetails) {
    setLogoAttributes();
  }

  const setFieldTextByID = (fieldId, value) => {
    const field = document.querySelector(`#${fieldId}`);
    if (field) field.innerText = value || "";
  };
  setFieldTextByID("AGENT_NAME", agentData.fullName || "");
  setFieldTextByID(
    "AGENT_BROKER_ADDRESS",
    td?.officeDetails?.nameandAddress
      ? formatOfficeDetails(td.officeDetails) // Handling for old transactions
      : agentData?.firmName && agentData?.address
      ? `${agentData?.firmName}\n${agentData?.address}`
      : agentData?.firmName && !agentData?.address
      ? `${agentData?.firmName}`
      : !agentData?.firmName && agentData?.address
      ? `${agentData?.address}`
      : ""
  );
  setFieldTextByID("AGENT_EMAIL", agentData.email && agentData.phoneNumber ? `${agentData.email} | ${formatPhoneNumber(agentData.phoneNumber)}` : agentData.email && !agentData.phoneNumber ? `${agentData.email}` : !agentData.email && agentData.phoneNumber ? `${formatPhoneNumber(agentData.phoneNumber)}` : "");
}

export function handleDifferentKeyOfClient({ clientArray, i, source }) {
  const newClients = clientArray?.map((client) => {
    let temp = {
      ...client,
    };
    if (temp?.isCorp) {
      temp.key = temp?.key + (i ? `_${i}` : "");
    } else {
      if (source === "AGENT") {
        temp.key = (temp?.key || temp.personId) + (i ? `_${i}` : "");
      } else {
        temp.key = temp?.personId + (i ? `_${i}` : "");
      }
    }
    return temp;
  });
  return newClients;
}

export function renderAgentSignatureBox({ rootDocData, openFor, agentType, savedValue, contractData }) {
  let i = 0;
  while (true) {
    let signatureBlockName = i ? `${agentType}_${i}` : agentType;
    let signatureElement = document.querySelectorAll(`[data-signature-block="${signatureBlockName}"]`);
    if (!signatureElement?.length) {
      break;
    }
    const currentBuyerClient = handleDifferentKeyOfClient({ clientArray: savedValue, i, source: "AGENT" });
    let brokerFields = buildAgentSignatureLabels({type: agentType, contractData});
    const sigBlock = buildSignatureBlocksForAgents({
      signers: currentBuyerClient,
      type: agentType,
      rootDocData: { ...rootDocData, personKey: `${rootDocData?.builtForId}${i ? `_${i}` : ""}`, key: `${rootDocData?.key}${i ? `_${i}` : ""}` },
      contractData,
      requiredOpenFor: openFor,
      brokerFields: brokerFields?.[i] || brokerFields?.default
    });
    signatureElement.forEach((element) => {
      element.innerHTML = sigBlock;
    });
    i++;
  }
}

let currentConfirmationModal = null;
const showManualEntryDateConfirmation = ({ messageTitle = "", isClosingDateField, inputValue, handleDataChange }) => {
  if (currentConfirmationModal) {
    currentConfirmationModal.destroy();
    currentConfirmationModal = null;
  }
  currentConfirmationModal = confirm({
    title: messageTitle,
    okText: "Yes",
    cancelText: "No",
    icon: <ExclamationCircleOutlined />,
    content: "Do you still want to proceed?",
    onOk() {
      let formattedData = {
        type: inputValue ? "date" : "text",
        value: inputValue || "N/A",
      };
      if (isClosingDateField) formattedData = formattedData.value;
      handleDataChange({ formattedData });
    },
    onCancel() {},
  });
};



export function handleManualEntryDateValidation({ event = {}, isClosingDateField, inputValue, handleDataChange, rootDocData }) {
  try {
    // const isClosingDateField = event?.target?.classList?.contains("closing-date-input");
    const parseDateToTimestamp = (dateString) => moment(dateString).valueOf();

    const getTextBeforeInput = (inputElement) => {
      const previousElement = inputElement?.parentElement?.previousElementSibling;
      return previousElement ? previousElement.textContent?.trim() : "";
    };
    // Checking for ClosingDate validation
    if (event.target.hasAttribute("data-checkDateValidation")) {
      const closingDateElement = document.querySelector(`[name="${event.target?.getAttribute("data-checkDateValidation")}"]`);
      // console.log("nextElement.value", closingDateElement.value, nextElement.value);
      if (closingDateElement && parseDateToTimestamp(closingDateElement.value) < parseDateToTimestamp(inputValue)) {
        const fieldName = getTextBeforeInput(closingDateElement);
        let messageTitle = `The selected date should not be after the ${fieldName}.`;
        showManualEntryDateConfirmation({ messageTitle, isClosingDateField, inputValue, handleDataChange });
        return;
      }
    }

    // Checking for group validation
    if (event.target.hasAttribute("data-dateValidationgroup")) {
      const groupElements = Array.from(document.querySelectorAll(`[data-dateValidationgroup="${event.target.getAttribute("data-dateValidationgroup")}"]`));
      if (event.target.hasAttribute("data-dateorder")) {
        const currentOrder = parseInt(event.target.dataset.dateorder);
        const previousElement = groupElements?.find((el) => el.dataset.dateorder === (currentOrder - 1)?.toString());
        const nextElement = groupElements?.find((el) => el.dataset.dateorder === (currentOrder + 1)?.toString());
        // console.log("nextElement.value",  nextElement?.value);
        const currentDateTimestamp = parseDateToTimestamp(inputValue);
        let messageTitle = ``;
        if (previousElement && currentDateTimestamp < parseDateToTimestamp(previousElement.value)) {
          const fieldName = getTextBeforeInput(previousElement);
          messageTitle = `The selected date should not be before the ${fieldName}.`;
        } else if (nextElement && currentDateTimestamp > parseDateToTimestamp(nextElement.value)) {
          const nextFieldName = getTextBeforeInput(nextElement);
          messageTitle = `The selected date should not be after the ${nextFieldName}.`;
        } else if (previousElement && nextElement && parseDateToTimestamp(previousElement.value) > currentDateTimestamp && currentDateTimestamp < parseDateToTimestamp(nextElement.value)) {
          const previousFieldName = getTextBeforeInput(previousElement);
          const nextFieldName = getTextBeforeInput(nextElement);
          messageTitle = `The selected date should not be before the ${previousFieldName} ${previousFieldName && nextFieldName ? " and " : ""}after the ${nextFieldName}.`;
        }

        if (messageTitle) {
          showManualEntryDateConfirmation({ messageTitle, isClosingDateField, inputValue, handleDataChange });
          return;
        }
      }
    }
    // console.log("everyThing is correct", inputValue);
    let formattedData = {
      type: inputValue ? "date" : "text",
      value: inputValue ? inputValue : [...noChangeCheckboxContractTypes, "ET"].includes(rootDocData?.contractType) ? "" : "N/A",
    };
    if (isClosingDateField) formattedData = formattedData.value;
    handleDataChange({ formattedData });
  } catch (error) {
    console.log("error happens in manually Entered date field", error?.message);
  }
}

export function handleConfirmModal({ event, specificData, removeSection, handleInputSave, currentUrlId }) {
  if (event.target.checked) {
    let checkReference = false;
    if (event.target.name === event.target.parentNode.parentNode.id) {
      const containerId = document.getElementById(event.target.name).id || event.target.parentNode.parentNode.id;
      checkReference = hasReferencedElement({ containerId, currentUrlId });
    }
    confirm({
      title: checkReference ? `This Section also contains the reference from the other parts of the document.` : `Remove Section`,
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure want to remove this Section?",
      onOk() {
        event.target.checked = true;
        const dirtyFieldsUpdate = removeSection(event.target);
        for (const key in dirtyFieldsUpdate) {
          specificData[key] = dirtyFieldsUpdate[key];
        }
        specificData[event.target.name] = [event.target.value];
        // console.log("dirtyFieldsUpdate", dirtyFieldsUpdate);
        handleInputSave(specificData);
        let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
        localData = {
          ...localData,
          ...specificData,
        };
        localStorage.setItem(currentUrlId, JSON.stringify(localData));
      },
      onCancel() {
        event.target.checked = false;
      },
    });
  } else {
    const dirtyFieldsUpdate = removeSection(event.target);
    for (const key in dirtyFieldsUpdate) {
      specificData[key] = dirtyFieldsUpdate[key];
    }
    specificData[event.target.name] = "";
    return specificData;
  }
}

function hasReferencedElement({ containerId, currentUrlId }) {
  const container = document.getElementById(containerId);
  if (container) {
    const elements = Array.from(container.querySelectorAll("[data-referenced-with-table]"));
    const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    const valueArray = elements
      .map((ele) => {
        const val = ele.dataset.referencedWithTable;
        // check if the respective referenced elements have value or date present in the table
        if (localData[val] && localData[val] !== "" && localData[val] !== 0 && localData[val] !== "0.00") {
          ele.style.backgroundColor = "rgb(64, 255, 53)";
          setTimeout(() => {
            ele.style.backgroundColor = "";
          }, 5000);
          return val;
        } else {
          return null;
        }
      })
      .filter((val) => val !== null);
    return valueArray.length > 0;
  }
  return false;
}

export function checkListingContainer(fieldToBeChecked, type) {
  const listingContainer = document.querySelector(".listingTableContainer");

  if (!listingContainer) {
    return null;
  }

  const inputFields = Array.from(listingContainer.querySelectorAll("input, textarea"));
  const listingCompanyDetailKeysArr = inputFields?.filter((e) => e.type !== "checkbox").map((field) => field.name) || [];

  switch (type) {
    case "checkIsPresent":
      return listingCompanyDetailKeysArr?.includes(fieldToBeChecked);
    case "getFieldNames":
      return listingCompanyDetailKeysArr;
    default:
      return null;
  }
}

export function pasteListingCoDataIntoSellingCo({ localData, specificData }) {
  let SellerAgentData = localData["SellerAgents"][0];
  let personId = SellerAgentData?.personId;
  specificData = {
    ...specificData,
    [`${personId}_firmName_buying`]: localData[`${personId}_firmName_selling`] || SellerAgentData?.firmName,
    [`${personId}_firmLicense_buying`]: localData[`${personId}_firmLicense_selling`] || SellerAgentData?.firmLicense,
    [`${personId}_address_buying`]: localData[`${personId}_address_selling`] || SellerAgentData?.address,
    [`${personId}_fullName_buying`]: localData[`${personId}_fullName_selling`] || SellerAgentData?.fullName,
    [`${personId}_license_buying`]: localData[`${personId}_license_selling`] || SellerAgentData?.license,
    [`${personId}_phoneNumber_buying`]: localData[`${personId}_phoneNumber_selling`] || SellerAgentData?.phoneNumber,
    [`${personId}_faxNumber_buying`]: localData[`${personId}_faxNumber_selling`] || SellerAgentData?.faxNumber,
    [`${personId}_email_buying`]: localData[`${personId}_email_selling`] || SellerAgentData?.email,
    [`${personId}_commission_buying`]: localData[`${personId}_commission_selling`] || SellerAgentData?.commission,
    [`${personId}_commissionPaidBy_buying`]: localData[`${personId}_commissionPaidBy_selling`] || SellerAgentData?.commissionPaidBy,
    [`${personId}_cellPhoneNumber_buying`]: localData[`${personId}_cellPhoneNumber_selling`] || SellerAgentData?.cellPhoneNumber,
    [`${personId}_otherRequest_buying`]: localData[`${personId}_otherRequest_selling`] || SellerAgentData?.otherRequest,
  };
  return specificData;
}

export function pasteSellingCoDataIntoListingCo({ localData, specificData }) {
  let BuyerAgentData = localData["BuyerAgents"][0];
  let personId = BuyerAgentData?.personId;
  specificData = {
    ...specificData,
    [`${personId}_firmName_selling`]: localData[`${personId}_firmName_buying`] || BuyerAgentData?.firmName,
    [`${personId}_firmLicense_selling`]: localData[`${personId}_firmLicense_buying`] || BuyerAgentData?.firmLicense,
    [`${personId}_address_selling`]: localData[`${personId}_address_buying`] || BuyerAgentData?.address,
    [`${personId}_fullName_selling`]: localData[`${personId}_fullName_buying`] || BuyerAgentData?.fullName,
    [`${personId}_license_selling`]: localData[`${personId}_license_buying`] || BuyerAgentData?.license,
    [`${personId}_phoneNumber_selling`]: localData[`${personId}_phoneNumber_buying`] || BuyerAgentData?.phoneNumber,
    [`${personId}_faxNumber_selling`]: localData[`${personId}_faxNumber_buying`] || BuyerAgentData?.faxNumber,
    [`${personId}_email_selling`]: localData[`${personId}_email_buying`] || BuyerAgentData?.email,
    [`${personId}_commission_selling`]: localData[`${personId}_commission_buying`] || BuyerAgentData?.commission,
    [`${personId}_commissionPaidBy_selling`]: localData[`${personId}_commissionPaidBy_buying`] || BuyerAgentData?.commissionPaidBy,
    [`${personId}_cellPhoneNumber_selling`]: localData[`${personId}_cellPhoneNumber_buying`] || BuyerAgentData?.cellPhoneNumber,
    [`${personId}_otherRequest_selling`]: localData[`${personId}_otherRequest_buying`] || BuyerAgentData?.otherRequest,
  };
  return specificData;
}

export function setSellingSideEmpty({ specificData, personId }) {
  specificData = {
    ...specificData,
    [`${personId}_firmName_selling`]: "",
    [`${personId}_firmLicense_selling`]: "",
    [`${personId}_address_selling`]: "",
    [`${personId}_fullName_selling`]: "",
    [`${personId}_license_selling`]: "",
    [`${personId}_phoneNumber_selling`]: "",
    [`${personId}_faxNumber_selling`]: "",
    [`${personId}_email_selling`]: "",
    [`${personId}_commission_selling`]: "",
    [`${personId}_commissionPaidBy_selling`]: "",
    [`${personId}_cellPhoneNumber_selling`]: "",
    [`${personId}_otherRequest_selling`]: "",
  };
  return specificData;
}
export function setBuyingSideEmpty({ specificData, personId }) {
  specificData = {
    ...specificData,
    [`${personId}_firmName_buying`]: "",
    [`${personId}_firmLicense_buying`]: "",
    [`${personId}_address_buying`]: "",
    [`${personId}_fullName_buying`]: "",
    [`${personId}_license_buying`]: "",
    [`${personId}_phoneNumber_buying`]: "",
    [`${personId}_faxNumber_buying`]: "",
    [`${personId}_email_buying`]: "",
    [`${personId}_commission_buying`]: "",
    [`${personId}_commissionPaidBy_buying`]: "",
    [`${personId}_cellPhoneNumber_buying`]: "",
    [`${personId}_otherRequest_buying`]: "",
  };
  return specificData;
}

export function updateIndividualChangedField({ event, personId, specificData }) {
  let fieldUpdated = event.target.name;
  let value = event.target.value;

  // firmName
  if (fieldUpdated === `${personId}_firmName_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_firmName_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_firmName_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_firmName_buying`]: value,
    };
  }

  // firmLicense
  if (fieldUpdated === `${personId}_firmLicense_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_firmLicense_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_firmLicense_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_firmLicense_buying`]: value,
    };
  }

  // address
  if (fieldUpdated === `${personId}_address_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_address_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_address_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_address_buying`]: value,
    };
  }

  // fullName
  if (fieldUpdated === `${personId}_fullName_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_fullName_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_fullName_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_fullName_buying`]: value,
    };
  }

  // license
  if (fieldUpdated === `${personId}_license_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_license_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_license_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_license_buying`]: value,
    };
  }

  // phoneNumber
  if (fieldUpdated === `${personId}_phoneNumber_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_phoneNumber_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_phoneNumber_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_phoneNumber_buying`]: value,
    };
  }

  // faxNumber
  if (fieldUpdated === `${personId}_faxNumber_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_faxNumber_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_faxNumber_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_faxNumber_buying`]: value,
    };
  }

  // email
  if (fieldUpdated === `${personId}_email_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_email_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_email_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_email_buying`]: value,
    };
  }

  // commission
  if (fieldUpdated === `${personId}_commission_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_commission_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_commission_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_commission_buying`]: value,
    };
  }

  // commissionPaidBy
  if (fieldUpdated === `${personId}_commissionPaidBy_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_commissionPaidBy_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_commissionPaidBy_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_commissionPaidBy_buying`]: value,
    };
  }

  // cellPhoneNumber
  if (fieldUpdated === `${personId}_cellPhoneNumber_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_cellPhoneNumber_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_cellPhoneNumber_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_cellPhoneNumber_buying`]: value,
    };
  }

  // otherRequest
  if (fieldUpdated === `${personId}_otherRequest_buying`) {
    specificData = {
      ...specificData,
      [`${personId}_otherRequest_selling`]: value,
    };
  }
  if (fieldUpdated === `${personId}_otherRequest_selling`) {
    specificData = {
      ...specificData,
      [`${personId}_otherRequest_buying`]: value,
    };
  }

  return specificData;
}

export function checkInCompleteSellers(clientsArray = []) {
  if (!clientsArray || !clientsArray?.length) {
    return true;
  }
  for (let ele of clientsArray) {
    if (ele?.isCorp && (!ele?.signers || !ele.signers?.length)) {
      return true;
    } else if (ele?.isCorp && ele?.signers?.length) {
      for (let el of ele.signers) {
        if (!el.personId) {
          return true;
        }
      }
    } else {
      if (ele?.isCorp === false && !ele?.personId) {
        return true;
      } else if (!ele.isCorp && !ele.personId && ele.key) {
        return true;
      }
    }
  }
  return false;
}

export const showDeleteConfirmToBroker = ({ event, currentUrlId, handleInputSave, rootDocData }) => {
  let localData = {};
  try {
    localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
  } catch (error) {
    return;
  }

  const personId = getAttr(event, "data-signer-personId");
  const uuidKey = getAttr(event, "data-signer-uuid-key");
  const signBlockIsFor = getAttr(event, "data-block-is-for");
  const labelType = getAttr(event, "data-labelType");
  const agentType = signBlockIsFor === "CO_BUYER_BROKER" ? "BuyerAgents" : "SellerAgents";
  //  console.log("signBlockIsFor", personId, uuidKey, signBlockIsFor);
  if (!localData[agentType] || localData[agentType].length === 0) {
    message.error("No brokers available to remove.");
    return;
  }
  let selectedAgentData = null;
  if (personId?.length === 24) {
    selectedAgentData = localData[agentType]?.find((el) => el.personId === personId && (labelType ? el.labelType === labelType : !el.labelType));
  } else if (uuidKey) {
    selectedAgentData = localData[agentType]?.find((el) => el.key === uuidKey);
  }

  if (!selectedAgentData) {
    message.error("No matching broker found.");
    return;
  }
  Modal.confirm({
    title: `Are you sure you want to remove ${selectedAgentData?.fullName || "this agent"} from this form?`,
    content: rootDocData?.contractType?.startsWith("DC_") || rootDocData?.contractType?.startsWith("WY_") ? "Note: This will also update all of the relavant input fields in the contract automatically." : listingContractTypes.includes(rootDocData?.contractType) ? "Note: This will also update the Section 3 fields automatically." : "",
    okText: "Yes",
    cancelText: "No",
    icon: <ExclamationCircleOutlined />,
    okType: "danger",
    onOk() {
      // Removing the agent using personId or key (uuidKey)
      if (personId?.length === 24) {
        localData[agentType] = localData[agentType].filter((el) => !(el.personId === personId && (labelType ? el.labelType === labelType : !el.labelType)));
      } else if (uuidKey) {
        localData[agentType] = localData[agentType].filter((el) => el.key !== uuidKey);
      }
      let transactionObj = {};
      if (rootDocData?.contractType?.startsWith("DC_") || rootDocData?.contractType?.startsWith("WY_") || listingContractTypes.includes(rootDocData?.contractType)) {
        updateSection3Fields({ localData, agents: localData[agentType], agentType, transactionObj, rootDocData, source: "MANUAL_UPDATE" });
      }
      handleInputSave({ [agentType]: localData[agentType], ...transactionObj });
      localStorage.setItem(currentUrlId, JSON.stringify(localData));
      setTimeout(() => {
        message.success("Broker removed successfully.");
      }, 2000);
    },
    onCancel() {},
  });
};

export function checkOnlySignersAllowedToEdit(rootDocData) {
  // const { openFor, contractType, RTDInitiator } = rootDocData || {};

  // signatureInfo?.some(el => ["BUYER", "BUYER_AGENT"].includes(el.roleType));
  // if (createOfferContractTypes.includes(contractType) && openFor === "SELLER_AGENT") {
  //   return true;
  // }
  // if (!createOfferContractTypes.includes(contractType)) {
  //   if (RTDInitiator === "BUYER" && openFor === "SELLER_AGENT") {
  //     return true;
  //   } else if (RTDInitiator === "SELLER" && openFor === "BUYER_AGENT") {
  //     return true;
  //   }
  // }
  return false;
}

export const combineBrokersFirmName = (agents, arrayStrType) => {
  if (!Array.isArray(agents)) return "";
  const firmsMap = new Map();
  if (arrayStrType === "CLIENTS") {
    agents.forEach((agent) => {
      if (agent && typeof agent === "object" && agent.isCorp) {
        agent.signers?.forEach((signer) => {
          const { resureFirmId, firmName } = signer;
          const key = resureFirmId ? String(resureFirmId) : firmName?.toLowerCase();
          if (key && !firmsMap.has(key)) {
            firmsMap.set(key, firmName);
          }
        });
      } else {
        const { resureFirmId, firmName } = agent;
        const key = resureFirmId ? String(resureFirmId) : firmName?.toLowerCase();
        if (key && !firmsMap.has(key)) {
          firmsMap.set(key, firmName);
        }
      }
    });
  } else {
    agents.forEach((agent) => {
      if (agent && typeof agent === "object") {
        const { resureFirmId, firmName } = agent;
        const key = resureFirmId ? String(resureFirmId) : firmName?.toLowerCase();
        if (key && !firmsMap.has(key)) {
          firmsMap.set(key, firmName);
        }
      }
    });
  }

  return Array.from(firmsMap.values()).join(", ");
};

export const updateSection3Fields = ({ localData = {}, agents = [], agentType, transactionObj, rootDocData={}, source }) => {
  try {
    const firmkey = agentType === "BuyerAgents" ? "[data-buyer-brokers-firm-list]" : "[data-seller-brokers-firm-list]";
    const brokerKey = agentType === "BuyerAgents" ? "[data-buyer-brokers-list]" : "[data-seller-brokers-list]";
    const agentStr = getFullNamesFromArray(agents);
    const brokerElements = document.querySelectorAll(brokerKey);
    // console.log("brokerElements", brokerElements);
    if (brokerElements?.length) {
      brokerElements.forEach((element) => {
        element.value = agentStr;
        localData[element.name] = agentStr;
        if (transactionObj) {
          transactionObj[element.name] = agentStr;
        }
        element.parentNode.dataset.replicatedValue = agentStr;
      });
    }

    const combinedFirmNames = combineBrokersFirmName(agents);
    const brokerFirmElements = document.querySelectorAll(firmkey);
    if (brokerFirmElements?.length) {
      brokerFirmElements.forEach((element) => {
        element.value = combinedFirmNames;
        localData[element.name] = combinedFirmNames;
        if (transactionObj) {
          transactionObj[element.name] = combinedFirmNames;
        }
        element.parentNode.dataset.replicatedValue = combinedFirmNames;
      });
    }

    if (rootDocData.contractType === "DC_ADBA") {
      const initiaorSideFirmElements = document.querySelectorAll("[data-brokers-firm-list]");
      if (initiaorSideFirmElements?.length) {
        const combinedFirmNames = combineBrokersFirmName(rootDocData.RTDInitiator === "BUYER" ? localData.BuyerAgents : localData.SellerAgents);
        initiaorSideFirmElements.forEach((element) => {
          element.value = combinedFirmNames;
          localData[element.name] = combinedFirmNames;
          if (transactionObj) {
            transactionObj[element.name] = combinedFirmNames;
          }
          element.parentNode.dataset.replicatedValue = combinedFirmNames;
        });
      }
    }
    if (source === "MANUAL_UPDATE") {
      updateBrokerList({ localData, rootDocData, source, transactionObj });
    }
    // updating the intiating agent details
    const initiagentDetails = getInitiatingAgentDetails({ localData, rootDocData });
    if (initiagentDetails) {
      const brokerFirmName = document.querySelectorAll(`[name="BrokerFirmName"]`);
      const brokerName = document.querySelectorAll(`[name="BrokerName"]`);
      brokerName?.forEach((element) => {
        if(!localData[element.name] || !rootDocData?.documentId) {
           element.value = initiagentDetails?.fullName || "";
        localData[element.name] = initiagentDetails?.fullName || "";
        if (transactionObj) {
          transactionObj[element.name] = initiagentDetails?.fullName || "";
        }
        if (element.parentNode.classList.contains("grow-with-input")) {
          element.parentNode.dataset.replicatedValue = initiagentDetails?.fullName || "";
        }
        }
      });
      brokerFirmName?.forEach((element) => {
        if(!localData[element.name] || !rootDocData?.documentId) {
           element.value = initiagentDetails?.firmName || "";
        localData[element.name] = initiagentDetails?.firmName || "";
        if (transactionObj) {
          transactionObj[element.name] = initiagentDetails?.firmName || "";
        }
        if (element.parentNode.classList.contains("grow-with-input")) {
          element.parentNode.dataset.replicatedValue = initiagentDetails?.firmName || "";
        }
        }
      });
    }
  } catch (error) {}
};

export const makeFieldsHiddenForTitleCompany = () => {
  netSheetFieldsHiddenToTitleCompany.forEach((fieldName) => {
    const fieldElement = document.querySelector(`[name="${fieldName}"]`);
    if (fieldElement) {
      // fieldElement.style.display = "none";
      fieldElement.style.visibility = "hidden";
    }
  });
};

export const removeAddButtonForReadOnly = () => {
  const netSheetAddItemBtn = document.querySelector("[data-add-item]");
  const netSheetAddLoanBtn = document.querySelector("[data-add-loan]");
  const netSheetRemoveItemBtn = document.querySelector("[data-remove-item]");
  if (netSheetAddItemBtn) {
    netSheetAddItemBtn.style.display = "none";
  }
  if (netSheetAddLoanBtn) {
    netSheetAddLoanBtn.style.display = "none";
  }
  if (netSheetRemoveItemBtn) {
    netSheetRemoveItemBtn.style.display = "none";
  }
};

export const updateBrokerList = ({ localData = {}, rootDocData, source, transactionObj }) => {
  try {
    const agentsArray = rootDocData?.RTDInitiator === "BUYER" ? localData?.BuyerAgents : localData?.SellerAgents;
    const brokerList = document.querySelectorAll(`[data-brokers-list]`);
    const brokerFirmList = document.querySelectorAll(`[data-brokers-firm-list]`);
    const agentStr = getFullNamesFromArray(agentsArray);
    brokerList?.forEach((element) => {
      element.value = agentStr;
      if (element.parentNode.classList.contains("grow-with-input")) {
        element.parentNode.dataset.replicatedValue = agentStr;
      }
    });
    brokerFirmList?.forEach((element) => {
      const combinedFirmNames = combineBrokersFirmName(agentsArray);
      element.value = combinedFirmNames;
      if (element.parentNode.classList.contains("grow-with-input")) {
        element.parentNode.dataset.replicatedValue = combinedFirmNames;
      }
    });
    const brokerFirmName = document.querySelectorAll(`[name="BrokerFirmName"]`);
    brokerFirmName?.forEach((element) => {
      element.value = localData?.officeDetails?.name || "";
      if (!localData[element.name]) {
        localData[element.name] = localData?.officeDetails?.name || "";
      }
      if (element.parentNode.classList.contains("grow-with-input")) {
        element.parentNode.dataset.replicatedValue = localData?.officeDetails?.name;
      }
    });

    if (rootDocData?.contractType === "DC_BAR") {
      const brokerName1 = document.querySelectorAll(`[name="BrokerName"]`);
      const brokerFirmName1 = document.querySelectorAll(`[name="BrokerFirmName"]`);
      const broker1Details = agentsArray[0] || {};
      brokerName1?.forEach((element) => {
        element.value = broker1Details?.fullName || "";
        if (element.parentNode.classList.contains("grow-with-input")) {
          element.parentNode.dataset.replicatedValue = broker1Details?.fullName;
        }
      });
      brokerFirmName1?.forEach((element) => {
        element.value = broker1Details?.firmName || "";
        if (element.parentNode.classList.contains("grow-with-input")) {
          element.parentNode.dataset.replicatedValue = broker1Details?.firmName;
        }
      });
    }
    if (["DC_BCLA", "DC_CLASLC"].includes(rootDocData?.contractType)) {
      const prefix = rootDocData?.contractType === "DC_BCLA" ? "Buyer" : "Seller";
      const brokerName1 = document.querySelectorAll(`[name="${prefix}BrokerName"]`);
      const brokerName2 = document.querySelectorAll(`[name="${prefix}BrokerName-A"]`);
      const brokerFirmName1 = document.querySelectorAll(`[name="${prefix}BrokerFirmName"]`);
      const brokerFirmName2 = document.querySelectorAll(`[name="${prefix}BrokerFirmName-A"]`);
      const agentsArray = rootDocData?.contractType === "DC_BCLA" ? localData?.BuyerAgents : localData?.SellerAgents;
      const broker1Details = agentsArray[0] || {};
      const broker2Details = agentsArray[1] || {};
      brokerName1?.forEach((element) => {
        element.value = broker1Details?.fullName || "";
        if (source === "MANUAL_UPDATE") {
          localData[element.name] = broker1Details?.fullName || "";
          if (transactionObj) {
            transactionObj[element.name] = broker1Details?.fullName || "";
          }
        }
        if (element.parentNode.classList.contains("grow-with-input")) {
          element.parentNode.dataset.replicatedValue = broker1Details?.fullName;
        }
      });
      brokerName2?.forEach((element) => {
        element.value = broker2Details?.fullName || "";
        if (source === "MANUAL_UPDATE") {
          localData[element.name] = broker2Details?.fullName || "";
          if (transactionObj) {
            transactionObj[element.name] = broker2Details?.fullName || "";
          }
        }
        if (element.parentNode.classList.contains("grow-with-input")) {
          element.parentNode.dataset.replicatedValue = broker2Details?.fullName;
        }
      });
      brokerFirmName1?.forEach((element) => {
        element.value = broker1Details?.firmName || "";
        if (source === "MANUAL_UPDATE") {
          localData[element.name] = broker1Details?.firmName || "";
          if (transactionObj) {
            transactionObj[element.name] = broker1Details?.firmName || "";
          }
        }
        if (element.parentNode.classList.contains("grow-with-input")) {
          element.parentNode.dataset.replicatedValue = broker1Details?.firmName;
        }
      });
      brokerFirmName2?.forEach((element) => {
        element.value = broker2Details?.firmName || "";
        if (source === "MANUAL_UPDATE") {
          localData[element.name] = broker2Details?.firmName || "";
          if (transactionObj) {
            transactionObj[element.name] = broker2Details?.firmName || "";
          }
        }
        if (element.parentNode.classList.contains("grow-with-input")) {
          element.parentNode.dataset.replicatedValue = broker2Details?.firmName;
        }
      });
    }
  } catch (error) {}
};

export const enablePurchasePriceForTitleCompany = () => {
  const purchasePriceElement = document.querySelector('[name="PurchasePrice"]');
  if (purchasePriceElement) {
    purchasePriceElement.disabled = false;
  }
};

export const setSelectedCompanyDataOfSOW = ({ selectedData, rootDocData, currentUrlId, handleInputSave }) => {
  try {
    let specificData = {};
    if (["SWA", "SPD"].includes(rootDocData?.contractType) && selectedData) {
      const fieldMappings = {
        NameOfWaterProvider: selectedData?.companyName,
        AddressOfWaterProvider: selectedData?.address,
        PhoneNoOfWaterProvider: selectedData?.phone ? formatPhoneNumber(selectedData?.phone) : "",
        WebsiteOfWaterProvider: selectedData?.website,
      };

      Object.entries(fieldMappings).forEach(([fieldName, value]) => {
        document.querySelectorAll(`[name="${fieldName}"]`).forEach((input) => {
          input.value = value || "";
          specificData = {
            ...specificData,
            [fieldName]: value,
          };
          if (input.parentNode.classList.contains("grow-with-input") || input.parentNode.classList.contains("grow-with-content")) {
            input.parentNode.dataset.replicatedValue = value;
          }
        });
      });
      let localData = JSON.parse(localStorage.getItem(currentUrlId));
      let finalData = {
        ...localData,
        ...specificData,
      };
      localStorage.setItem(currentUrlId, JSON.stringify(finalData));
      handleInputSave(specificData);
    }
  } catch (error) {
    console.error("Error setting input values:", error);
  }
};

export const getBuildDataForCustomerdocs = ({ clientDocId, contractType, contractId, currentAgentDetails, delegate, transactionData = {}, item, officeDetails, docSecondItem, userAuthKey }) => {
  let BuyerAgents = [],
    SellerAgents = [];
  let Buyers = [];
  let Sellers = [];
  const isBuyerCustomerDoc = buyerCustomerDocsContractTypes.includes(contractType);
  if (isBuyerCustomerDoc) {
    Buyers = item?.isProperty ? transactionData?.Sellers : transactionData?.Buyers;
    BuyerAgents = item?.isProperty ? transactionData?.SellerAgents : transactionData?.BuyerAgents;
  } else {
    Sellers = item?.isProperty ? transactionData?.Sellers : transactionData?.Buyers;
    SellerAgents = item?.isProperty ? transactionData?.SellerAgents : transactionData?.BuyerAgents;
  }

  let buildData = {
    urlData: {
      ...(isBuyerCustomerDoc && Buyers?.length ? { Buyers } : Sellers?.length ? { Sellers } : {}),
      ...(BuyerAgents?.length > 0 ? { BuyerAgents, BuyerBrokersList: getFullNamesFromArray(BuyerAgents), BuyerBrokersFirmList: combineBrokersFirmName(BuyerAgents) } : {}),
      ...(SellerAgents?.length > 0 ? { SellerAgents, SellerBrokersList: getFullNamesFromArray(SellerAgents), SellerBrokersFirmList: combineBrokersFirmName(SellerAgents) } : {}),

      ...(docSecondItem?.contractType === "LCAE" ? { LcaeCheckedListingContract: "ERTBListingContract" } : docSecondItem?.contractType === "LCAES_ERTL" ? { LcaeCheckedListingContract: "ERTLListingContract" } : docSecondItem?.contractType === "LCAES_ETCT" ? { LcaeCheckedListingContract: "ExclusiveTenantListingContract" } : {}),

      ...(docSecondItem?.contractType === "LCAE" ? { LcaeInitatingParty: "LcaeInitatingPartyBuyer" } : docSecondItem?.contractType === "LCAES_ERTL" ? { LcaeInitatingParty: "LcaeInitatingPartyLandlord" } : docSecondItem?.contractType === "LCAES_ETCT" ? { LcaeInitatingParty: "LcaeInitatingPartyTenant" } : {}),
      officeDetails,
      ...(docSecondItem?.contractType ? { ...transactionData } : {}),
    },
    openFor: isBuyerCustomerDoc ? "BUYER_AGENT" : "SELLER_AGENT",
    RTDInitiator: isBuyerCustomerDoc ? "BUYER" : "SELLER",
    ...(delegate ? { delegateOwnerId: currentAgentDetails?._id } : {}),
    ...(docSecondItem?.contractType && clientDocId ? { clientDocId } : {}),
    ...(docSecondItem?.contractType === "LCAES" ? { propertyId: item?.propertyId } : {}),
    openForPropertyDoc: isBuyerCustomerDoc ? "BUYER_AGENT" : "SELLER_AGENT",
    contractId: contractId,
    contractType: contractType,
    token: userAuthKey,
    builtForSection: "DOCUMENT",
    builtForId: currentAgentDetails?._id,
    key: currentAgentDetails?._id,
    signable: true,
  };
  return buildData;
};

export const checkForDeleteClientDoc = (item) => {
  const { contractType, buyerSignStatus, sellerSignStatus, buyerAgentSignStatus, sellerAgentSignStatus } = item || {};
  if (sellerCustomerDocsContractTypes.includes(contractType)) {
    if (contractType === "WFD" && sellerSignStatus === "SUBMITTED") {
      return false;
    }
    if (sellerSignStatus === "SUBMITTED" && sellerAgentSignStatus === "SUBMITTED") {
      return false;
    }
    return true;
  }
  if (["ERTB", "CB_ERTB", "BDB", "LCAE", "WY_ATAE_ERTB", "FRASCONA_BDB"].includes(contractType)) {
    if (buyerSignStatus === "SUBMITTED" && buyerAgentSignStatus === "SUBMITTED") {
      return false;
    }
    return true;
  }
};

export const hasPropertyDocsMenuItems = ({ eachDoc, getCoordinateItem }) => {
  return eachDoc?.doc_second?.length > 0 || canPropertyDocItemBeDeleted({ eachDoc, getCoordinateItem });
};

export const canPropertyDocItemBeDeleted = ({ eachDoc, getCoordinateItem }) => {
  if (!eachDoc || eachDoc?.storageType === "FOLDER") {
    return false;
  }
  if (eachDoc?.isCustomerDoc && !checkForDeleteClientDoc(eachDoc)) {
    return false;
  }
  const isSellingNotExecuted = isSellingNotExecutedFunc({ item: getCoordinateItem });
  if (listingContractTypes.includes(eachDoc?.contractType) && getCoordinateItem?.isProperty && isSellingNotExecuted) {
    return false;
  }
  const isbuyingNotExecuted = getCoordinateItem?.status === "ARCHIVED" || getCoordinateItem?.status === "CLOSED" || getCoordinateItem?.status === "ACCEPTED" || getCoordinateItem?.status === "TERMINATED";
  if (createOfferContractTypes.includes(eachDoc?.contractType) && isbuyingNotExecuted) {
    return false;
  }
  if (counterOfferContractTypes.includes(eachDoc?.contractType) && eachDoc?.buyerSignStatus === "SUBMITTED" && eachDoc?.sellerSignStatus === "SUBMITTED") {
    return false;
  }
  return true;
};

export const updateBrokerFirmList = ({ localData = {}, dataselector, clientsArray }) => {
  try {
    const brokerFirmList = combineBrokersFirmName(clientsArray, "CLIENTS");
    const elements = document.querySelectorAll(dataselector);
    // console.log("brokerFirmList", brokerFirmList, {clientsArray});
    if (elements.length) {
      elements.forEach((element) => {
        element.value = brokerFirmList;
        localData[element.name] = brokerFirmList;
        element.parentNode.dataset.replicatedValue = brokerFirmList;
      });
    }
  } catch (error) {}
};

export const isNetSheetDataModified = ({ originalData = {}, updatedData = {} }) => {
  const excludedKeys = new Set([
    "Buyers",
    "Sellers",
    "BuyerAgents",
    "SellerAgents",
    "DocumentDate",
    "FullAddress",
    "officeDetails",
    "urlId",
    "AutoFillDates",
  ]);

  const allKeys = new Set([...Object.keys(originalData), ...Object.keys(updatedData)]);

  for (let key of allKeys) {
    if (excludedKeys.has(key)) continue;

    const val1 = originalData[key];
    const val2 = updatedData[key];

    // 🚫 Skip booleans, arrays, objects
    if (
      typeof val1 === "boolean" ||
      typeof val2 === "boolean" ||
      Array.isArray(val1) ||
      Array.isArray(val2) ||
      (val1 && typeof val1 === "object") ||
      (val2 && typeof val2 === "object")
    ) {
      continue;
    }

    // ✅ Treat missing key as change
    const hasVal1 = Object.prototype.hasOwnProperty.call(originalData, key);
    const hasVal2 = Object.prototype.hasOwnProperty.call(updatedData, key);

    if (!hasVal1 || !hasVal2) {
      console.log("🔁 New or missing key:", key);
      return true;
    }

    // 🔄 Normalize
    const normalizedVal1 = (val1 ?? "").toString().trim();
    const normalizedVal2 = (val2 ?? "").toString().trim();

    if (normalizedVal1 !== normalizedVal2) {
      console.log("🔁 Value changed:", key, "→", normalizedVal1, "!=", normalizedVal2);
      return true;
    }
  }

  return false;
};

export const netSheetConfirmationModal = ({ from, dispatch, contractStoreHandle, urlId, contractAuthKey, loclData, rootDocData, goBack }) => {
  confirm({
    title: `Would you like to apply these changes to all the Offer's Net Sheets for this listing?`,
    content: "",
    okText: "Yes",
    cancelText: "No",
    onOk() {
      if (from === "save") {
        dispatch(contractStoreHandle.autoSaveContract({ currentUrlId: urlId, contractAuthKey, netSheetUpdateType: "NET_SHEET_DATA_TRANSFER" }));
      } else if (from === "back") {
        dispatch(contractStoreHandle.autoSaveContract({ currentUrlId: urlId, contractAuthKey, goBack, netSheetUpdateType: "NET_SHEET_DATA_TRANSFER" }));
      }
      // rootDocData.TotalEstimateNetProceeds = loclData?.TotalEstimateNetProceeds
      rootDocData.netSheetTransactionData = loclData
    },
    onCancel() {
      message.success("Changes have been applied to this document only.");
      if (from === "back") {
        goBack();
      }
      // rootDocData.TotalEstimateNetProceeds = loclData?.TotalEstimateNetProceeds
      rootDocData.netSheetTransactionData = loclData
    },
  });
};

export const netSheetItemRemoveConfirmationModal = ({ loanKey, name, label, value, labelKey, amtKey, source }, { td, currentUrlId, dispatch, contractAuthKey }) => {
  try {
    // GROUP-1 > loanKey > FOR LOANS
    // GROUP-2 > name, label, value > FOR PREDEFINED ITEMS
    // GROUP-2 > labelKey, amtKey > FOR CUSTOM ITEMS
    confirm({
      title: `Are you sure you want to remove ${loanKey ? loanKey : label ? label : labelKey && td[labelKey] ? td[labelKey] : 'this item'}?`,
      content: "This action cannot be undone.",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        let removeItemsFromTd = {};
        if (source === "LOAN_ITEM" && loanKey) {
          // console.log('loanKey', loanKey, 'td[labelKey]', td[labelKey]);
          removeItemsFromTd = { ...removeItemsFromTd, [loanKey]: td[loanKey] };
          delete td[loanKey];
        } else if (source === "ADDITIONAL_ITEM" && name) {
          // console.log('name', name, ' label ', label, ' value ', value);
          removeItemsFromTd = { ...removeItemsFromTd, [name]: value };
          delete td[name];
        } else if (source === "CUSTOM_ITEM" && labelKey) {
          // console.log('labelKey ', labelKey, ' td[labelKey] ', td[labelKey], " amtKey ", amtKey, ' td[amtKey] ', td[amtKey]);
          removeItemsFromTd = { ...removeItemsFromTd, [labelKey]: td[labelKey] };
          delete td[labelKey];
          if (amtKey){
            removeItemsFromTd = { ...removeItemsFromTd, [amtKey]: td[amtKey] };
            delete td[amtKey];
          }
        }
        let dataToSet = calculateFinalNetSheetPrice({ td });
        if (dataToSet && Object.keys(dataToSet).length > 0) {
          td = { ...td, ...dataToSet };
        }
        localStorage.setItem(currentUrlId, JSON.stringify(td));
        dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey, valueObj: dataToSet, removeItemsFromTd }));
        // message.success("Item removed successfully.");
      },
      onCancel() {
        message.info("Item removal cancelled.");
      },
    });
  } catch (error) {
    console.error("Error in netSheetItemRemoveConfirmationModal:", error);
  }
}

export const applyDynamicWidth = (fieldNames, minWidth = 65) => {
  try {
     const tempSpan = document.createElement("span");
  Object.assign(tempSpan.style, {
    position: "absolute",
    visibility: "hidden",
    whiteSpace: "nowrap",
  });
  document.body.appendChild(tempSpan);

  let maxW = minWidth;
  fieldNames.forEach((name) => {
    const els = document.getElementsByName(name);
    if (!els.length) return;
    // Calulating the width of the first element’s current text
    tempSpan.textContent = els[0].value || "";
    maxW = Math.max(maxW, tempSpan.offsetWidth + 2);
  });

  document.body.removeChild(tempSpan);
  // applying the width to all instances of each field name
  fieldNames.forEach((name) => {
    document.getElementsByName(name).forEach((el) => {
      el.style.width = `${maxW}px`;
    });
  });
  } catch (error) {
    
  }
 
};


export const checkIfAddMeBtnVisible = ({ clientsArray, addAsSelf, rootDocData }) => {
     const corpArray = clientsArray?.filter((el) => el.isCorp);
    if (!addAsSelf) return false;
    // if (rootDocData?.contractType.startsWith("WY_")) {
    //   const agentData = getInitiatingAgentDetails({ localData: JSON.parse(localStorage.getItem(currentUrlId)), rootDocData });
    //   return agentData && Object.keys(agentData)?.length > 0;
    // }
    return !!(!clientsArray?.length || (corpArray?.length && !corpArray?.[0]?.signers?.length))

  } 

export const extractEmailsAndPhones = (clients) => {
  if (!Array.isArray(clients) || clients.length === 0) {
    return { allEmails: "", allPhoneNumbers: "" };
  }
  const emails = [];
  const phoneNumbers = [];
  clients.forEach((client) => {
    if (client.isCorp && Array.isArray(client.signers)) {
      client.signers.forEach((signer) => {
        if (signer.email) emails.push(signer.email);
        if (signer.phoneNumber) phoneNumbers.push(signer.phoneNumber);
      });
    } else {
      if (client.email) emails.push(client.email);
      if (client.phoneNumber) phoneNumbers.push(client.phoneNumber);
    }
  });

  return {
    emailList: emails.join(", "),
    phoneNumberList: phoneNumbers.join(", "),
  };
};

  
export const showClientsListWithSeperateInputs = ({ clientsArray = [], clientKey }) => {
  const lowerKey = clientKey?.toLowerCase();
  const clientDivs = document.querySelectorAll(`[data-${lowerKey}-individual-list-block]`);
  if (!clientDivs.length || !clientKey) return;

  const isBuyer = clientKey === "Buyers";
  const clientEditAttribute = isBuyer ? "data-buyer-edit-icon" : "data-seller-edit-icon";
  const labelText = isBuyer ? "Buyer " : "Seller";

  const createInputWrapper = (client = {}) => {
    const wrapper = document.createElement("div");
    const label = document.createElement("span");
    label.textContent = labelText;

    const growSpan = document.createElement("span");
    growSpan.className = "grow-with-input";
    const input = document.createElement("input");
    input.type = "text";
    input.readOnly = true;
    input.className = "clickable";
    // if (client.personId || client.key) {
    //   input.name = `${clientKey}_name_${client.personId || client.key}`;
    // }
    if (client.fullName) {
      input.value = client.fullName;
      growSpan.dataset.replicatedValue = client.fullName;
    }

    input.setAttribute(clientEditAttribute, true);
    growSpan.appendChild(input);
    wrapper.appendChild(label);
    wrapper.appendChild(growSpan);

    return wrapper;
  };

  clientDivs.forEach((div) => {
    div.innerHTML = "";
    if (clientsArray.length === 0) {
      div.appendChild(createInputWrapper());
    } else {
      clientsArray.forEach((client) => {
        div.appendChild(createInputWrapper(client));
      });
    }
  });
};

export const addLineNumbers = (formElement) => {
  if (!formElement) return;

  const wyLineNumbers = formElement.querySelector("#WY_lineNumbers");
  if (!wyLineNumbers) return;

  const lineNumbersWrapper = document.createElement("div");
  lineNumbersWrapper.className = "line-numbers-container no-block";

  const lineNumbersEl = document.createElement("div");
  lineNumbersEl.id = "lineNumbers";
  lineNumbersEl.className = "line-numbers";

  const contentWrapper = document.createElement("div");
  contentWrapper.className = "content";
  contentWrapper.appendChild(wyLineNumbers);

  lineNumbersWrapper.appendChild(lineNumbersEl);
  lineNumbersWrapper.appendChild(contentWrapper);

  formElement.appendChild(lineNumbersWrapper);

  const schedule = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));

  const updateLineNumbers = () => {
    const contentEl = document.querySelector(".content");
    const lineNumbersEl = document.querySelector("#lineNumbers");
    if (!contentEl || !lineNumbersEl) return;

    const cs = getComputedStyle(contentEl);
    let lh = parseFloat(cs.lineHeight);
    if (!lh || Number.isNaN(lh)) {
      lh = parseFloat(cs.fontSize) * 1.4;
    }

    const padTop = parseFloat(cs.paddingTop) || 0;
    const padBottom = parseFloat(cs.paddingBottom) || 0;

    let height = contentEl.scrollHeight - padTop - padBottom;

    const first = contentEl.firstElementChild;
    const last = contentEl.lastElementChild;
    if (first) height -= parseFloat(getComputedStyle(first).marginTop) || 0;
    if (last) height -= parseFloat(getComputedStyle(last).marginBottom) || 0;

    const totalLines = Math.max(1, Math.floor(height / lh + 0.001));

    const frag = document.createDocumentFragment();
    for (let i = 1; i <= totalLines; i++) {
      const span = document.createElement("span");
      span.textContent = String(i);
      span.style.height = `${lh}px`;
      span.style.lineHeight = `${lh}px`;
      frag.appendChild(span);
    }
    lineNumbersEl.innerHTML = "";
    lineNumbersEl.appendChild(frag);
  };

  const run = () => schedule(updateLineNumbers);
  run();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => schedule(updateLineNumbers));
  }

  const ce = document.querySelector(".content");
  const ro = new ResizeObserver(() => updateLineNumbers());
  if (ce) ro.observe(ce);

  const mo = new MutationObserver(() => schedule(updateLineNumbers));
  if (ce) mo.observe(ce, { childList: true, subtree: true, characterData: true });

  window.addEventListener("resize", updateLineNumbers);

  return () => {
    try {
      ro.disconnect();
      mo.disconnect();
      window.removeEventListener("resize", updateLineNumbers);
    } catch {}
  };
};

const handleSingleElementDisable = ({ element, readOnlyEffect, effect }) => {
    if (!element?.style) return;
    if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
      if (element.type !== "checkbox" && element.type !== "radio" && !element.classList.contains("relativeDateInput") && !element.classList.contains("relativeTimeInput") && element.name !== "FullAddress") {
        element.readOnly = readOnlyEffect;
        // Adding or removing class based on readOnlyEffect
        element.classList.toggle("noAutoSave", readOnlyEffect);
      } else {
        element.style.pointerEvents = effect;
      }
    } else {
      element.style.pointerEvents = effect;
      if (element.classList.contains("bi-pencil-square")) {
        element.style.color = effect === "none" ? "#808080" : "#0000FF";
      }
    }
  };

const disableElements = (elements, effect) => {
    const readOnlyEffect = effect === "none" ? true : false;
    elements = Array.isArray(elements) ? elements : [elements];
    elements.forEach((element) => {
      if (element instanceof NodeList || Array.isArray(element)) {
        element.forEach((node) => {
          handleSingleElementDisable({ element: node, readOnlyEffect, effect });
        });
      } else {
        handleSingleElementDisable({ element, readOnlyEffect, effect });
      }
    });
  };

  const disableElementsByName = (arrayOfInputNames = [], effect) => {
    arrayOfInputNames.forEach((el) => {
      let inputElement = document.querySelectorAll(`[name="${el}"]`);
      disableElements(inputElement, effect);
    });
  };

export const handleIfPresent = ({signatureSequence, localData}) => {
  //to disable sections on basis of signatures present
  if(signatureSequence?.disableElements?.length > 0){
    for(let element of signatureSequence?.disableElements){
      //check if in present elements
      element?.ifPresent?.forEach((ele)=>{
        if(typeof ele === 'object'){
          if(localData?.[ele.key]?.[0] === ele?.value){
            element?.signatures?.forEach((disableEle)=>{
              const block = document.querySelector(`[data-signature-block="${disableEle}"]`);
              if (block) {
                const activeSigners = block.querySelectorAll('.active-signer');
                activeSigners.forEach((el) => {
                  el.classList.remove('active-signer');
                  el.classList.remove('clickable');
                  el.classList.add('inactive-signer');
                });
              }
            });
            disableElementsByName(element?.inputs || [], "none");
          }
        }
        else{
          // lets make it common later
        }
      })
    }
  }
}

export const initStrikeThroughPopup = (transactionData, handleInputSave, currentUrlId) => {
  const popup = document.createElement("div");
  popup.id = "text-popup";
  popup.style.cssText = `
    position:absolute;
    background:#fff;
    border:1px solid #ccc; border-radius:6px; box-shadow:0 2px 6px rgba(0,0,0,.15);
    padding:4px 8px; z-index:1000; display:none;
    gap:4px; flex-direction:row;
  `;

  const strikeBtn = document.createElement("button");
  strikeBtn.textContent = "S̶";
  const highlightBtn = document.createElement("button");
  highlightBtn.textContent = "H";

  [strikeBtn, highlightBtn].forEach((btn) => {
    btn.style.cssText = `
      background: #EFF7FC;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      font-weight: bold;
      transition: all 0.2s ease;
    `;
    btn.addEventListener("mouseenter", () => (btn.style.background = "#e5e7eb"));
    btn.addEventListener("mouseleave", () => (btn.style.background = "#f3f4f6"));
    btn.addEventListener("mousedown", () => (btn.style.transform = "scale(0.95)"));
    btn.addEventListener("mouseup", () => (btn.style.transform = "scale(1)"));
  });

  popup.appendChild(strikeBtn);
  popup.appendChild(highlightBtn);
  document.body.appendChild(popup);

  const getDomPath = (el) => {
    if (!el) return "";

    if (el?.nodeType === Node.TEXT_NODE) el = el?.parentElement;

    let current = el;

    while (current && ["INPUT", "TEXTAREA", "SELECT"].includes(current?.tagName)) {
      current = current?.parentElement;
    }

    const path = [];
    while (current && current?.nodeType === 1) {
      let tag = current?.tagName?.toLowerCase();
      if (current?.id) tag += `#${current?.id}`;
      else if (current?.className) tag += `.${current?.className.split(" ")[0]}`;
      path.unshift(tag);
      current = current?.parentElement;
    }
    return path.join(" > ");
  };

  const cleanText = (text) =>
    text
      ?.replace(/\n/g, " ")
      ?.replace(/[^\S\u00A0]+/g, " ")
      ?.replace(/ {2,}/g, " ");

  const getTextContext = (range, wordCount = 3) => {
    const fullText = range?.startContainer?.textContent || "";
    const selText = range?.toString();
    const startIdx = fullText?.indexOf(selText);

    if (startIdx === -1) return { before: "", after: "" };

    const before = fullText?.slice(0, startIdx)?.split(/\s+/)?.slice(-wordCount)?.join(" ");

    const after = fullText
      ?.slice(startIdx + selText.length)
      ?.split(/\s+/)
      ?.slice(0, wordCount)
      ?.join(" ");

    return { before, after };
  };

  const wrapSelection = (type) => {
    const sel = window.getSelection();
    if (!sel || sel?.rangeCount === 0) return;
    const range = sel?.getRangeAt(0);
    if (range?.collapsed) return;

    const rawSel = range?.toString();
  
    const hasLeadingSpace = /^\s/.test(rawSel);
    const hasTrailingSpace = /\s$/.test(rawSel);
    const selectedText = rawSel?.replace(/^\s+|\s+$/g, (m) => "\u00A0".repeat(m.length));

    if (!selectedText) return;

    const arrKey = type === "strike" ? "strikeThroughSections" : "highlightSections";
    const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    const existing = localData[arrKey] || [];

    const contents = range?.cloneContents();
    const walker = document.createTreeWalker(contents, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, null);
    let node;
    const newEntries = [];

    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) {
        const txt = cleanText(node.nodeValue);
        if (txt) {
          const context = getTextContext(range, 3);
          newEntries.push({
            text: txt, // temporary, we'll inject leading/trailing NBSPs below if needed
            path: getDomPath(range?.startContainer?.parentElement),
            contextBefore: context.before,
            contextAfter: context.after,
          });
        }
      } else if (node?.nodeType === 1 && (node?.tagName === "INPUT" || node?.tagName === "TEXTAREA")) {
        newEntries.push({
          text: null,
          path: getDomPath(node),
          contextBefore: "",
          contextAfter: "",
        });
      }
    }

    if (newEntries?.length > 0) {
      if (hasLeadingSpace) {
        for (let i = 0; i < newEntries?.length; i++) {
          if (newEntries[i]?.text) {
            newEntries[i].text = "\u00A0" + newEntries[i].text;
            break;
          }
        }
      }
      
      if (hasTrailingSpace) {
        for (let i = newEntries?.length - 1; i >= 0; i--) {
          if (newEntries[i]?.text) {
            newEntries[i].text = newEntries[i].text + "\u00A0";
            break;
          }
        }
      }
    }

    let changed = false;
    newEntries?.forEach((entry) => {
      const alreadyExists = existing?.some((e) => e.path === entry.path && cleanText(e.text || "") === cleanText(entry.text || "") && cleanText(e.contextBefore || "") === cleanText(entry.contextBefore || "") && cleanText(e.contextAfter || "") === cleanText(entry.contextAfter || ""));

      if (!alreadyExists) {
        existing?.push(entry);
        changed = true;
      }
    });

    localData[arrKey] = existing;
    localStorage.setItem(currentUrlId, JSON.stringify(localData));

    if (changed) handleInputSave({ [arrKey]: existing });

    sel?.removeAllRanges();
    popup.style.display = "none";
  };

  const unwrapSelection = (type) => {
    const sel = window.getSelection();
    if (!sel || sel?.rangeCount === 0) return;
    const range = sel?.getRangeAt(0);
    if (range?.collapsed) return;

    const arrKey = type === "strike" ? "strikeThroughSections" : "highlightSections";
    const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    const existing = localData[arrKey] || [];

    const selectedText = cleanText(sel.toString());
    if (!selectedText) return;

    const context = getTextContext(range, 3);
    const { before: contextBefore, after: contextAfter } = context;

    const normalize = (s) => (s ? cleanText(s) : "");
    let changed = false;
    const updated = [];

    existing.forEach((entry) => {
      const entryTextRaw = entry?.text || null;
      if (!entryTextRaw) {
        updated?.push(entry);
        return;
      }

      const entryText = normalize(entryTextRaw);
      if (!entryText) {
        updated.push(entry);
        return;
      }

      if (entryText === selectedText) {
        changed = true;
        return;
      }

      if (selectedText?.includes(entryText) && selectedText !== entryText) {
        changed = true;
        return;
      }

      const idx = entryText?.indexOf(selectedText);
      if (idx !== -1 && selectedText?.length < entryText?.length) {
        const beforePart = entryText?.slice(0, idx);
        const afterPart = entryText?.slice(idx + selectedText.length);

        if (beforePart.trim()) {
          updated.push({
            ...entry,
            text: beforePart,
            contextBefore: entry?.contextBefore || contextBefore,
            contextAfter: cleanText(selectedText?.split(/\s+/)?.slice(0, 3)?.join(" ")),
          });
        }

        if (afterPart.trim()) {
          updated.push({
            ...entry,
            text: afterPart,
            contextBefore: cleanText(selectedText?.split(/\s+/)?.slice(-3)?.join(" ")),
            contextAfter: entry?.contextAfter || contextAfter,
          });
        }

        changed = true;
        return;
      }

      if (normalize(entry?.contextBefore || "").includes(normalize(contextBefore)) || normalize(entry?.contextAfter || "").includes(normalize(contextAfter))) {
        const intersectionIdx = selectedText?.indexOf(entryText);
        if (intersectionIdx !== -1 && selectedText?.length < entryText?.length) {
          const beforePart = entryText?.slice(0, intersectionIdx);
          const afterPart = entryText?.slice(intersectionIdx + selectedText?.length);
          if (beforePart.trim()) {
            updated.push({
              ...entry,
              text: beforePart,
              contextBefore: entry?.contextBefore,
              contextAfter: contextBefore,
            });
          }
          if (afterPart?.trim()) {
            updated.push({
              ...entry,
              text: afterPart,
              contextBefore: contextAfter,
              contextAfter: entry.contextAfter,
            });
          }
          changed = true;
          return;
        }
      }

      updated.push(entry);
    });

    if (changed) {
      localData[arrKey] = updated;
      localStorage.setItem(currentUrlId, JSON.stringify(localData));
      try {
        handleInputSave({ [arrKey]: updated });
      } catch (err) {
        console.warn("handleInputSave threw:", err);
      }
    }

    sel?.removeAllRanges();
    const popup = document.getElementById("text-popup");
    if (popup) popup.style.display = "none";
  };

  const handleBtnClick = (type) => {
    const sel = window.getSelection();
    if (!sel || sel?.rangeCount === 0) return;

    const attr = type === "strike" ? "data-strike-through-section" : "data-highlight-section";
    let node = sel?.anchorNode;
    while (node && node !== document.body) {
      if (node?.nodeType === 1 && node?.hasAttribute(attr)) break;
      node = node?.parentElement;
    }

    if (node && node.hasAttribute(attr)) unwrapSelection(type);
    else wrapSelection(type);
    popup.style.display = "none";
  };

  strikeBtn?.addEventListener("click", () => handleBtnClick("strike"));
  highlightBtn?.addEventListener("click", () => handleBtnClick("highlight"));

  const mouseUpHandler = () => {
    const sel = window.getSelection();
    if (sel && !sel.isCollapsed) {
      const rect = sel.getRangeAt(0).getBoundingClientRect();
      popup.style.top = `${rect.top + window.scrollY - 40}px`;
      popup.style.left = `${rect.left + rect.width / 2}px`;
      popup.style.display = "flex";

      let node = sel?.anchorNode;
      let isStriked = false;
      let isHighlighted = false;
      while (node) {
        if (node?.nodeType === 1 && node?.hasAttribute("data-strike-through-section")) isStriked = true;
        if (node?.nodeType === 1 && node?.hasAttribute("data-highlight-section")) isHighlighted = true;
        node = node?.parentElement;
      }

      if (isStriked) {
        strikeBtn.style.display = "inline-block";
        highlightBtn.style.display = "none";
        strikeBtn.style.background = "#124E8E";
        strikeBtn.style.color = "#fff";
      } else if (isHighlighted) {
        strikeBtn.style.display = "none";
        highlightBtn.style.display = "inline-block";
        highlightBtn.style.background = "yellow";
        highlightBtn.style.color = "#000";
      } else {
        strikeBtn.style.display = "inline-block";
        highlightBtn.style.display = "inline-block";
        strikeBtn.style.background = "#EFF7FC";
        strikeBtn.style.color = "#000";
        highlightBtn.style.background = "#EFF7FC";
        highlightBtn.style.color = "#000";
      }
    } else {
      popup.style.display = "none";
    }
  };

  document.addEventListener("mouseup", mouseUpHandler);

  return () => {
    popup.remove();
    document.removeEventListener("mouseup", mouseUpHandler);
  };
};

export const confirmDeleteTitleSigner = ({ event, currentUrlId, handleInputSave, rootDocData, dispatch, contractAuthKey }) => {
  confirm({
    title: `Are you sure you want to remove this signer from this Document?`,
    content: "",
    okText: "Yes",
    cancelText: "No",
    icon: <ExclamationCircleOutlined />,
    okType: "danger",
    onOk() {
      let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
      localStorage.setItem(currentUrlId, JSON.stringify({ ...localData, TitleReps: [] }));
      dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey, valueObj: { TitleReps: [] } }));
    },
    onCancel() {}

  })
};

export const handleOrGroupChange = ({ event, specificData }) => {
  const el = event.target;
  const groupAttr = el.getAttribute("data-or-group");
  if (!groupAttr) return;

  // Split into base name and current group ID
  const [baseName, currentGroupId] = groupAttr.split("_grp");

  // Find all elements sharing the same base group
  const allGroupElements = document.querySelectorAll(`[data-or-group^="${baseName}_grp"]`);

  // Check if the current element has a value
  const hasValue = checkIfHasValue(el);

  if (hasValue) {
    // Clear all other groups (not the current one)
    allGroupElements.forEach((node) => {
      const nodeAttr = node.getAttribute("data-or-group");
      if (!nodeAttr) return;

      const [, nodeGroupId] = nodeAttr.split("_grp");

      // Only clear nodes that are in *different* groups
      if (nodeGroupId !== currentGroupId) {
        clearElementValue({ el: node, specificData });
      }
    });
  }
};

/** Checks if element has a "filled" value */
function checkIfHasValue(el) {
  if (el.type === "checkbox" || el.type === "radio") {
    return el.checked;
  }
  if (el.tagName === "SELECT") {
    return el.value !== "" && el.value !== undefined && el.value !== null;
  }
  return el.value?.trim?.() !== "";
}

/** Clears or unsets an element’s value */
function clearElementValue({ el, specificData }) {
  if (el.type === "checkbox" || el.type === "radio") {
    el.checked = false;
    specificData[el.name] = "";
  } else if (el.tagName === "SELECT") {
    el.value = "";
    specificData[el.name] = "";
  } else {
    el.value = "";
    specificData[el.name] = "";
  }
}
